(function(){
  "use strict";

  /* ============================ CONFIG ============================ */
  var URL_PRENOMS='https://admin.mytomette.fr/json/prenoms.json';
  var URL_LOGOS  ='https://admin.mytomette.fr/mt-logo-catalog-v2.php?resource=manifest';
  var URL_LOGOS_FALLBACK='https://admin.mytomette.fr/json/logos.json';
  var URL_FONTS  ='https://admin.mytomette.fr/json/fonts.json?v=20261006';
  var CONFIG_BASE=window.MT_CONFIG_I18N.absoluteUrl("https://mytomette.myshopify.com/pages/configurateur-app");
  var PHOTO_HEX='https://cdn.shopify.com/s/files/1/1039/8665/9668/files/file_00000000fec87243a998a236f69b846b.webp?v=1782338066';
  var PHOTO_SQ ='https://cdn.shopify.com/s/files/1/1039/8665/9668/files/file_0000000095b071f48d1938042d6500fb.webp?v=1782929936';
  /* bornes de l'hexagone terre cuite mesurées dans cleantomette.webp (1254x1254, fond blanc) :
     l'hexagone occupe x[0.0638..0.9338] y[0.0973..0.8740]. On recadre sur ces bords puis on étire
     l'hexagone pour remplir le cadre géométrique (repère des gravures, identique à l'admin).
     La photo catalogue de départ partage ce cadrage -> même recadrage pour une bascule sans saut. */
var CLEAN_HEX={x0:0.0726,y0:0.0909,x1:0.9306,y1:0.8628};
  /* Carre : par defaut auto-detecte (squareTileBox). Pour FIGER un carre exact si l'auto-detection
     derive, renseigner ici les fractions du carreau terre cuite : {x0,y0,x1,y1} (0..1). Prioritaire. */
  var SQ_TILE_BOX={x0:0.0583,y0:0.0575,x1:0.9333,y1:0.9325}; /* carreau carre MESURE sur
     file_0000000095b071...webp (1200x1200) : face plate reelle, hors biseau du bas. Rend le calage
     photo identique au SVG. -> a mettre a jour si tu changes la photo carree (ou remettre null pour auto). */

  var SHAPES={
    hexa  :{label:'Hexagonale',dim:'12 × 10 cm',cls:'hex',price:15,wcm:12,hcm:10},
    carree:{label:'Carrée',    dim:'13 × 13 cm',cls:'sq', price:20,wcm:13,hcm:13}
  };
  var DATA=(function(){try{return JSON.parse(document.getElementById('mtpData').textContent)||{};}catch(e){return {};}})();
  var RECIPE=DATA.recipe||{}, MODE=DATA.mode||'guided', CFG_DATA=DATA.cfg||window.MT_CONFIG_I18N.url("/pages/configurateur-app");
  var SHAPE_LABELS=DATA.shapeLabels||{};
  /* LABO Atelier mobile : sur telephone, un texte a GABARIT
     ($Julie$ [& $Benjamin$]) devient UN SEUL champ libre — l'utilisateur
     ecrit ce qu'il veut, separateurs compris. Une pastille, une ligne. */
  try{
    if(window.matchMedia&&matchMedia('(max-width: 759px)').matches){
      (RECIPE.elements||[]).forEach(function(el,idx){
        var f=el&&el.field; if(!el||el.type!=='text'||!f)return;
        var tpl=String(el.text||'');
        if(!(f.kind==='template'||/\$[^$\n]+\$/.test(tpl)))return;
        var rendu=tpl.replace(/\[([^\[\]]*)\]/g,'$1')
                     .replace(/\$([^$\n]+)\$/g,function(_,n){return n.trim();})
                     .replace(/\s+/g,' ').trim();
        var req=false; (f.vars||[]).forEach(function(v){ if(v&&v.required)req=true; });
        el.text=rendu;
        el.field={ kind:'text', key:(f.key||('f'+idx)), label:(f.label||'Votre texte'),
          example:rendu, required:req, placeholder:(f.placeholder||('Ex : '+rendu)) };
      });
    }
  }catch(e){}
  var VARR=DATA.variants||[], VARIANTS={}; VARR.forEach(function(v){VARIANTS[v.k]=v;});
  var HOLE_FEE=3, SIZE_REF=12, BURN='#4a2616';
  var _revealLive=null; /* bascule photo -> aperçu live à la 1re personnalisation (desktop) */
  var HOLE_DIAM_CM=0.4, HOLE_CLEAR=0.025;

  var WRAP_MARGIN={hex:0.88, sq:0.80};
  var SQ_SCALE=1.2;
  /* Forme d'origine de la recette (celle ou les tailles ont ete concues). Comme setShape() du
     configurateur complet : au changement de forme, la gravure est mise a l'echelle par le rapport
     des HAUTEURS (coef = hcm_forme / hcm_origine), positions gardees en fractions. Ainsi hexa->carre
     agrandit le visuel (13/10) pour remplir la tomette plus haute au lieu de paraitre petit.
     coef = 1 sur la forme d'origine -> rendu identique a avant sur cette forme. */
  var BASE_SHAPE=(RECIPE.shape&&SHAPES[RECIPE.shape])?RECIPE.shape:'hexa';
  function shapeScale(shapeKey){ var b=SHAPES[BASE_SHAPE]||SHAPES.hexa, s=SHAPES[shapeKey]||b; return s.hcm/b.hcm; }
  var PHRASE_LABELS=['La signature','L\'espiègle','La complice','La piquante'];

  var HEART_FALLBACK='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.2-4.7-9.5-9.2C1 8.9 2.6 5.8 5.7 5.8c1.9 0 3.3 1 4.3 2.3 1-1.3 2.4-2.3 4.3-2.3 3.1 0 4.7 3.1 3.2 6C19.2 16.3 12 21 12 21z"/></svg>';

  var FONT_ALIASES=[
    {id:'cormorant',    label:'Cormorant',   css:"'Cormorant Garamond',serif",grp:'eleg',family:'Cormorant Garamond'},
    {id:'dmsans',       label:'DM Sans',     css:"'DM Sans',sans-serif",       grp:'mod', family:'DM Sans'},
    {id:'Reenie Beanie',label:'Reenie Beanie',css:"'Reenie Beanie',cursive",   grp:'manu',family:'Reenie Beanie'},
    {id:'Indie Flower', label:'Indie Flower', css:"'Indie Flower',cursive",     grp:'manu',family:'Indie Flower'}
  ];
  var FONTREG={};
  function fbCss(cat){return cat==='eleg'?'serif':(cat==='mod'?'sans-serif':'cursive');}
  function mergeFonts(defs){
    (defs||[]).forEach(function(d){
      if(!d||!d.id)return;
      var prev=FONTREG[d.id]||{};
      /* Une recette peut référencer un alias sans répéter ses vraies métadonnées.
         Dans ce cas on conserve l'alias fiable déjà déclaré ci-dessus. */
      if(d.source==='alias'&&prev.id)return;
      FONTREG[d.id]={id:d.id,label:d.name||prev.label||d.id,css:"'"+(d.family||prev.family||d.id)+"',"+fbCss(d.category||prev.grp),grp:d.category||prev.grp||'manu',family:d.family||prev.family||d.id,weights:d.weights||prev.weights||'400',source:d.source||prev.source,url:d.url||prev.url,ttf:d.ttf||d.laser||d.otf||prev.ttf,midOff:(typeof d.midOff==='number'?d.midOff:(prev.midOff==null?null:prev.midOff))};
    });
  }
  function buildFonts(defs){
    FONTREG={}; FONT_ALIASES.forEach(function(a){FONTREG[a.id]=a;});
    mergeFonts(defs);
  }
  function fontById(id){return FONTREG[id]||FONTREG['cormorant']||FONT_ALIASES[0];}
  function famOf(id){var fr=FONTREG[id];return (fr&&fr.family)?fr.family:id;}
  var _mteInjected={}, _mteFontLoads={}, _mtpFontRender=0, _mtpWebFontLoads={};
  function mtpQueueFontRender(){
    if(_mtpFontRender)return;
    _mtpFontRender=requestAnimationFrame(function(){
      _mtpFontRender=0;
      mtMidCacheClear();
      _mtLayCacheClearIfAny();
      reRender();
    });
  }
  function engraveTtfUrl(fontId,w){ var fam=famOf(fontId), fr=FONTREG[fontId]||{}, stat=mtStat(fam,w||cDefWeight(fontId)); var u=(stat&&stat.url);
    /* famille Google : le woff statique @fontsource D'ABORD — le TTF variable
       complet (Caveat 207 Ko...) ne sert plus que de repli. Sans ce choix,
       le premier dessin partait en TTF avant que la table statique existe. */
    if(!u&&typeof fontsourceWoff==='function'&&((fr.source==='google')||(typeof MTE_VARDEF!=='undefined'&&MTE_VARDEF[fam]!=null)||(typeof FONT_TTF!=='undefined'&&FONT_TTF[fam]))){
      u=fontsourceWoff(fam,mtNearestDeclaredWeight(fr,w||cDefWeight(fontId)));
    }
    u=u||(typeof FONT_TTF!=='undefined'&&FONT_TTF[fam])||(fr.ttf||fr.url); if(u)return u; if((fr.source==='google'||(typeof MTE_VARDEF!=='undefined'&&MTE_VARDEF[fam]!=null))&&typeof fontsourceWoff==='function'){ /* JAMAIS le premier poids declare : "100;200;...;900" (Montserrat) donnait
       le Thin au laser. Ici aucun statique n'est enregistre => le poids demande est
       le poids par defaut de la famille. */
    var _w=mtNearestDeclaredWeight(fr,(typeof MTE_VARDEF!=='undefined'&&MTE_VARDEF[fam]!=null)?MTE_VARDEF[fam]:400); return fontsourceWoff(fam,_w); } return null; }  /* repli general : Google sans TTF local -> @fontsource (meme fichier SVG+canvas) */
  function engraveFamFor(fontId,w){
    w=w||cDefWeight(fontId);
    var fam=famOf(fontId), url=engraveTtfUrl(fontId,w); if(!url)return null;
    var stat=mtStat(fam,w);var alias='MTE_'+String(fam).replace(/[^A-Za-z0-9]+/g,'_')+'_'+(stat?stat.weight:('r'+w));
    if(!_mteInjected[alias]){
      _mteInjected[alias]=1;
      var st=document.getElementById('mtpEngraveFaces'); if(!st){st=document.createElement('style');st.id='mtpEngraveFaces';document.head.appendChild(st);}
      st.textContent+="@font-face{font-family:'"+alias+"';src:url('"+url+"');"+(stat?("font-weight:"+stat.weight+";"):"")+"font-display:swap}";
      try{ if(document.fonts&&document.fonts.load){
        _mteFontLoads[alias]=document.fonts.load((stat?stat.weight+" ":"")+"24px '"+alias+"'").then(function(){
          mtpQueueFontRender(); return true;
        },function(){return false;});
      } }catch(e){}
    }
    return alias;
  }
  function engraveCss(fontId,w){ var fr=fontById(fontId), base=(fr&&fr.css)||'cursive', al=engraveFamFor(fontId,w); return al?("'"+al+"',"+base):base; }
  function injectFaces(defs){
    var css=(defs||[]).filter(function(d){return d.source==='url'&&d.url;}).map(function(d){return "@font-face{font-family:'"+(d.family||d.id)+"';src:url('"+d.url+"');font-display:swap}";}).join('\n');
    var st=document.getElementById('mtpFaces'); if(!st){st=document.createElement('style');st.id='mtpFaces';document.head.appendChild(st);}
    st.textContent=css;
  }
  function injectRecipeFonts(){
    var rf=(RECIPE.fonts||[]); if(!rf.length)return;
    var css=rf.filter(function(f){return f&&f.family&&f.url;}).map(function(f){return "@font-face{font-family:'"+f.family+"';src:url('"+f.url+"');font-display:swap}";}).join('\n');
    if(!css)return;
    var st=document.getElementById('mtpRecipeFaces'); if(!st){st=document.createElement('style');st.id='mtpRecipeFaces';document.head.appendChild(st);}
    st.textContent=css;
  }

  /* ============================ ÉTAT ============================ */
  var state={shape:(RECIPE.shape||'carree'), hole:!!RECIPE.hole, values:{}, swaps:{}, dropped:{}, els:[]};
  function initLinkedVariant(){
    try{
      var id=new URLSearchParams(location.search).get('variant');
      if(!id)return;
      var v=VARR.filter(function(item){return String(item.id)===id;})[0];
      var key=v&&String(v.k).split('|');
      if(!key||key.length!==2||!SHAPES[key[0]]||!/^[01]$/.test(key[1]))return;
      state.shape=key[0];
      state.hole=key[1]==='1';
    }catch(e){}
  }
  var qty=1;
  var EDIT_KEY='';   /* cle de ligne panier a remplacer (edition depuis le panier) */
  var LOGOCAT={};

  /* ============================ HELPERS ============================ */
  function $(id){return document.getElementById(id);}
  function clamp(v,a,b){return v<a?a:(v>b?b:v);}
  function norm(s){return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  function escHtml(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  function photoUrl(sq){return sq?PHOTO_SQ:PHOTO_HEX;}
  function sizeCqwFor(size,shapeKey){return (size||6)*(SIZE_REF/SHAPES[shapeKey].wcm);}
  function toast(msg){var t=$('mtpToast');t.textContent=msg;t.classList.add('mtp-on');setTimeout(function(){t.classList.remove('mtp-on');},2000);}
  var _mtpCreep=null;
  function setLoad(pct,cap,sub){var f=$('mtpLoadFill');if(f&&pct!=null)f.style.width=Math.max(0,Math.min(100,pct))+'%';var c=$('mtpLoadCap');if(c&&cap!=null)c.textContent=cap;var s=$('mtpLoadSub');if(s&&sub!=null)s.textContent=sub;}
  function stopCreep(){if(_mtpCreep){clearInterval(_mtpCreep);_mtpCreep=null;}}
  function startCreep(from,to,ms){stopCreep();var f=$('mtpLoadFill');if(!f)return;var t0=Date.now();f.style.width=from+'%';_mtpCreep=setInterval(function(){var k=Math.min(1,(Date.now()-t0)/ms),w=from+(to-from)*k;f.style.width=w.toFixed(1)+'%';if(k>=1)stopCreep();},180);}
  function showLoading(){var o=$('mtpLoad');o.classList.add('mtp-on');o.setAttribute('aria-hidden','false');setLoad(6,null,null);}
  function hideLoading(){stopCreep();var o=$('mtpLoad');o.classList.remove('mtp-on');o.setAttribute('aria-hidden','true');}

  function usableWidthFrac(x,y,shapeKey){
    x=(x!=null?x:0.5); y=(y!=null?y:0.5);
    var edge=2*Math.min(x,1-x);
    if(SHAPES[shapeKey].cls==='sq'){return Math.max(0.2,Math.min(0.97,edge*0.985));}
    var hexW=1-Math.abs(y-0.5);
    return Math.max(0.2,Math.min(hexW*0.96,edge*0.96));
  }
  function usableW(x,y,shapeKey){
    return usableWidthFrac(x,y,shapeKey)*(SHAPES[shapeKey].cls==='sq'?WRAP_MARGIN.sq:WRAP_MARGIN.hex);
  }
  function wrapCanvasLines(ctx,txt,maxW){
    var out=[];
    String(txt).split('\n').forEach(function(para){
      var words=para.split(' '), cur=words.length?words[0]:'';
      for(var i=1;i<words.length;i++){
        if(ctx.measureText(cur+' '+words[i]).width>maxW){out.push(cur);cur=words[i];}
        else cur=cur+' '+words[i];
      }
      out.push(cur);
    });
    return out;
  }

  function sanitizeSvg(raw){
    var s=String(raw);
    s=s.replace(/<\?xml[\s\S]*?\?>/gi,'').replace(/<!DOCTYPE[\s\S]*?>/gi,'');
    s=s.replace(/<script[\s\S]*?<\/script>/gi,'').replace(/<style[\s\S]*?<\/style>/gi,'');
    s=s.replace(/<foreignObject[\s\S]*?<\/foreignObject>/gi,'');
    s=s.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*')/gi,'');
    s=s.replace(/\sclass\s*=\s*("[^"]*"|'[^']*')/gi,'');
    var m=s.match(/<svg[\s\S]*<\/svg>/i); if(!m)return null; s=m[0];
    s=s.replace(/(fill|stroke)\s*=\s*("[^"]*"|'[^']*')/gi,function(f,p,val){var v=val.slice(1,-1).trim().toLowerCase();if(v==='none'||v==='currentcolor')return p+'="'+v+'"';return p+'="currentColor"';});
    s=s.replace(/(fill|stroke)\s*=\s*([^\s"'>\/]+)/gi,function(f,p,val){var v=val.trim().toLowerCase();if(v==='none'||v==='currentcolor')return p+'="'+v+'"';return p+'="currentColor"';});
    s=s.replace(/(fill|stroke)\s*:\s*([^;"')]+)/gi,function(f,p,val){var v=val.trim().toLowerCase();if(v==='none'||v==='currentcolor'||v==='inherit'||v==='transparent'||/^url\(/.test(v))return f;return p+':currentColor';});
    if(!/<svg\b[^>]*\bfill\s*=/i.test(s)) s=s.replace(/<svg\b/i,'<svg fill="currentColor"');
    return s;
  }
  function heartSvg(){return HEART_FALLBACK;}
  function logoBoxOf(svg){var bx={w:24,h:24},m=String(svg).match(/viewBox\s*=\s*["']([-\d.\s]+)["']/);if(m){var a=m[1].trim().split(/\s+/);if(a.length===4){bx.w=parseFloat(a[2])||24;bx.h=parseFloat(a[3])||24;}}return bx;}
  function ensureSvgSize(svg){var bx=logoBoxOf(svg);return String(svg).replace(/<svg\b([^>]*)>/i,function(m,a){a=a.replace(/\s(width|height)\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi,'');return '<svg'+a+' width="'+bx.w+'" height="'+bx.h+'">';});}
  function burnSvgOf(){var svg=heartSvg().replace(/currentColor/g,BURN);if(!/xmlns=/.test(svg))svg=svg.replace(/<svg\b/i,'<svg xmlns="http://www.w3.org/2000/svg"');return ensureSvgSize(svg);}

  /* ============================ IMAGES ============================ */
  var _bgCache={}, _logoSlots={}, _maskCv=null, _tintCv=null, _tintCx=null, _raf=0, _ro=null;
  function drawContain(ctx,img,W,H){var iw=img.naturalWidth||img.width,ih=img.naturalHeight||img.height;if(!iw||!ih){ctx.drawImage(img,0,0,W,H);return;}var sc=Math.min(W/iw,H/ih),dw=iw*sc,dh=ih*sc;ctx.drawImage(img,(W-dw)/2,(H-dh)/2,dw,dh);}
  function containRect(img,W,H){var iw=img&&(img.naturalWidth||img.width),ih=img&&(img.naturalHeight||img.height);if(!iw||!ih)return {x:0,y:0,w:W,h:H};var sc=Math.min(W/iw,H/ih),dw=iw*sc,dh=ih*sc;return {x:(W-dw)/2,y:(H-dh)/2,w:dw,h:dh};}
  function hexPath(ctx,W,H){ctx.beginPath();ctx.moveTo(0.25*W,0);ctx.lineTo(0.75*W,0);ctx.lineTo(W,0.5*H);ctx.lineTo(0.75*W,H);ctx.lineTo(0.25*W,H);ctx.lineTo(0,0.5*H);ctx.closePath();}
  function roundRectPath(ctx,x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();}
  function shapePathLive(ctx,sq,W,H){if(sq){roundRectPath(ctx,0,0,W,H,Math.round(W*0.03));}else{hexPath(ctx,W,H);}}
  function tileMaskOf(im){
    if(!im)return null; if(im._mtMask!==undefined)return im._mtMask; var m=null;
    try{var w=im.naturalWidth||im.width,h=im.naturalHeight||im.height;
      if(w&&h){var c=document.createElement('canvas');c.width=w;c.height=h;var x=c.getContext('2d');x.drawImage(im,0,0);
        var d=x.getImageData(0,0,w,h),pp=d.data,i;for(i=0;i<pp.length;i+=4){pp[i+3]=pp[i+3]>=150?255:0;}x.putImageData(d,0,0);m=c;}
    }catch(e){m=null;} try{im._mtMask=m;}catch(e){} return m;
  }
  /* Construit, depuis la photo brute cleantomette (fond blanc), un hexagone PROPRE :
     - tex  : la zone terre cuite recadrée pile sur ses bords (servira de texture, étirée pour
              remplir le cadre géométrique des gravures, identique à l'admin)
     - mask : masque alpha suivant exactement le bord de l'hexagone (blanc -> transparent),
              avec une transition douce sur le liseré (anti-crénelage).
     Repli : si la lecture des pixels est bloquée (CORS), masque hexagonal géométrique. */
  function buildCleanHex(im){
    var iw=im.naturalWidth||im.width, ih=im.naturalHeight||im.height;
    var sx=Math.round(CLEAN_HEX.x0*iw), sy=Math.round(CLEAN_HEX.y0*ih);
    var sw=Math.round((CLEAN_HEX.x1-CLEAN_HEX.x0)*iw), sh=Math.round((CLEAN_HEX.y1-CLEAN_HEX.y0)*ih);
    if(sw<2||sh<2){sw=iw;sh=ih;sx=0;sy=0;}
    var tex=document.createElement('canvas'); tex.width=sw; tex.height=sh;
    tex.getContext('2d').drawImage(im,sx,sy,sw,sh,0,0,sw,sh);
    var mask=document.createElement('canvas'); mask.width=sw; mask.height=sh;
    var mc=mask.getContext('2d');
    try{
      mc.drawImage(tex,0,0);
      var d=mc.getImageData(0,0,sw,sh), p=d.data, i, r,g,b,mx,mn,sp,a;
      for(i=0;i<p.length;i+=4){
        r=p[i];g=p[i+1];b=p[i+2];
        mx=r>g?(r>b?r:b):(g>b?g:b); mn=r<g?(r<b?r:b):(g<b?g:b); sp=mx-mn;
        /* terre cuite = chaud (r>=g>=b) et coloré (écart de canaux) ; blanc/gris ~ écart faible */
        if(r>=g&&g>=b&&r>90){ a=sp<=12?0:(sp>=38?255:Math.round((sp-12)/26*255)); }
        else { a=0; }
        p[i]=0;p[i+1]=0;p[i+2]=0;p[i+3]=a;
      }
      mc.putImageData(d,0,0);
    }catch(e){
      /* CORS bloqué -> hexagone géométrique plein */
      mc.clearRect(0,0,sw,sh); mc.fillStyle='#000'; hexPath(mc,sw,sh); mc.fill();
    }
    return {tex:tex, mask:mask};
  }
  /* Bornes (fractions) du carreau terre cuite DANS la photo carree : carreau insere sur fond blanc
     -> on detecte sa bbox pour y caler la gravure, en gardant le fond blanc autour. Repli (CORS/echec)
     : plein cadre. Mesure sur reduction, mise en cache sur l'image. */
  function squareTileBox(im){
    if(im._mtSqBox!==undefined)return im._mtSqBox;
    if(SQ_TILE_BOX){ try{im._mtSqBox=SQ_TILE_BOX;}catch(e){} return SQ_TILE_BOX; }
    var box=null;
    try{
      var iw=im.naturalWidth||im.width, ih=im.naturalHeight||im.height;
      if(iw&&ih){
        var sw=220, sh=Math.max(1,Math.round(sw*ih/iw));
        var c=document.createElement('canvas');c.width=sw;c.height=sh;
        var x=c.getContext('2d');x.drawImage(im,0,0,sw,sh);
        var d=x.getImageData(0,0,sw,sh).data;
        /* terre cuite franche : oranger sature. Blanc (r-b~0) et ombre grise/douce ecartes. */
        var terra=function(i){ var r=d[i],g=d[i+1],b=d[i+2]; return r>95 && (r-b)>24 && (r-g)>0; };
        /* profils colonne/ligne : une colonne/ligne = carreau seulement si une GRANDE part de ses
           pixels est terre cuite franche. L'ombre (fine bande, faible couverture) n'est jamais retenue
           -> aucun grignotage de l'ombre. */
        var needC=Math.max(6,Math.round(sh*0.40)), needR=Math.max(6,Math.round(sw*0.40));
        var x0=-1,x1=-1,y0=-1,y1=-1, xx,yy,i,n;
        for(xx=0;xx<sw;xx++){ n=0; for(yy=0;yy<sh;yy++){ i=(yy*sw+xx)*4; if(terra(i))n++; } if(n>=needC){ if(x0<0)x0=xx; x1=xx; } }
        for(yy=0;yy<sh;yy++){ n=0; for(xx=0;xx<sw;xx++){ i=(yy*sw+xx)*4; if(terra(i))n++; } if(n>=needR){ if(y0<0)y0=yy; y1=yy; } }
        if(x0>=0&&y0>=0&&(x1-x0)>sw*0.2&&(y1-y0)>sh*0.2){
          /* VRAI carre, centre sur la face detectee ; cote = plus petite dimension -> ne deborde
             jamais dans l'ombre meme si un axe est leg. surestime. */
          var cxp=(x0+x1+1)/2, cyp=(y0+y1+1)/2, half=Math.min((x1-x0+1),(y1-y0+1))/2;
          box={x0:(cxp-half)/sw, y0:(cyp-half)/sh, x1:(cxp+half)/sw, y1:(cyp+half)/sh};
        }
      }
    }catch(e){box=null;}
    if(!box)box={x0:0,y0:0,x1:1,y1:1};
    try{im._mtSqBox=box;}catch(e){}
    return box;
  }
  function getBgImg(sq){
    var key=sq?'sq':'hex'; if(_bgCache[key])return _bgCache[key];
    var slot={img:null,mask:null,ready:false};_bgCache[key]=slot;
    var im=new Image();im.crossOrigin='anonymous';
    function done(){
      if(sq){ slot.img=im; slot.mask=tileMaskOf(im); }
      else { var b=buildCleanHex(im); slot.img=b.tex; slot.mask=b.mask; slot.full=im; }
      slot.ready=true;scheduleLive();
    }
    im.onload=function(){if(im.decode){im.decode().then(done).catch(done);}else done();};
    im.onerror=function(){slot.ready=true;scheduleLive();};
    im.src=photoUrl(sq); return slot;
  }
  /* Cache des SVG nettoyes : sanitizeSvg applique 9 regex globales sur des chaines
     pouvant atteindre 180 Ko, et etait appelee ~100 fois au demarrage pour ~35 dessins.
     Le cache est vide par seedRecipeLogos() des que LOGOCAT change. */
  var _svgClean=Object.create(null);
  function logoSvgRaw(id){var k=String(id);var h=_svgClean[k];if(h!==undefined)return h;var l=LOGOCAT[k],c=null;if(l&&l.svg)c=sanitizeSvg(l.svg);var r=c||HEART_FALLBACK;_svgClean[k]=r;return r;}
  function burnLogoSvg(id){var svg=logoSvgRaw(id).replace(/currentColor/g,BURN);if(!/xmlns=/.test(svg))svg=svg.replace(/<svg\b/i,'<svg xmlns="http://www.w3.org/2000/svg"');return ensureSvgSize(svg);}
  function getLogoImg(id){
    var svg=burnLogoSvg(id), slot=_logoSlots[id];
    if(slot&&slot.svg===svg)return slot;
    slot={img:null,ready:false,svg:svg,box:logoBoxOf(svg)};_logoSlots[id]=slot;
    var im=new Image();
    function done(){slot.img=im;slot.ready=true;scheduleLive();}
    im.onload=function(){if(im.decode){im.decode().then(done).catch(done);}else done();};
    im.onerror=function(){slot.ready=true;};
    im.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg); return slot;
  }
  function tintMaskC(srcCanvas,color){
    if(!_tintCv){_tintCv=document.createElement('canvas');_tintCx=_tintCv.getContext('2d');}
    if(_tintCv.width!==srcCanvas.width||_tintCv.height!==srcCanvas.height){_tintCv.width=srcCanvas.width;_tintCv.height=srcCanvas.height;}
    var x=_tintCx;x.globalCompositeOperation='source-over';x.clearRect(0,0,_tintCv.width,_tintCv.height);
    x.drawImage(srcCanvas,0,0);x.globalCompositeOperation='source-in';x.fillStyle=color;x.fillRect(0,0,_tintCv.width,_tintCv.height);
    x.globalCompositeOperation='source-over';return _tintCv;
  }

  /* Effets dessinés par l’atelier expert : même géométrie Bézier en pixels
     pour l’aperçu et en millimètres pour le SVG. Les smallcaps de l’expert
     sont gravées en majuscules ; elles sont mesurées ainsi, avant le fit. */
  function normRot(r){ r=Math.round(+r||0)%360; if(r>180)r-=360; if(r<-180)r+=360; if(Math.abs(r)<4)r=0; return r; }
  function mtHasCurve(e){ return Math.abs(+e.curve||0)>=1; }
  function mtEffectText(e,txt){ txt=String(txt==null?'':txt); return e.smallcaps?txt.toUpperCase():txt; }
  function mtTextLines(e){ return ((e.lines&&e.lines.length)?e.lines:String(e.text||'').split('\n')).map(function(ln){return mtEffectText(e,ln);}); }
  function mtCopyEffects(from,to){
    if(from.type==='text'){ if(mtHasCurve(from))to.curve=clamp(+from.curve,-100,100); if(from.smallcaps)to.smallcaps=true; }
    var r=normRot(from.rot); if(r)to.rot=r; return to;
  }
  function _arcLayout(widths,total,fs,cv){
    var aw=Math.max(total*1.12,fs*3),d=(cv>0)?1:-1,sag=Math.abs(cv)*aw*0.42;
    var P0x=-aw/2,P2x=aw/2,P1y=2*(-d*sag);
    function bez(t){var mt=1-t;return {x:mt*mt*P0x+t*t*P2x,y:2*mt*t*P1y};}
    function dbez(t){var mt=1-t;return {x:2*mt*(0-P0x)+2*t*(P2x-0),y:2*mt*P1y+2*t*(-P1y)};}
    var N=160,acc=[0],prev=bez(0),k;
    for(k=1;k<=N;k++){var p=bez(k/N);acc.push(acc[k-1]+Math.hypot(p.x-prev.x,p.y-prev.y));prev=p;}
    var aL=acc[N];
    function tAt(L){L=Math.max(0,Math.min(aL,L));for(var q=1;q<=N;q++){if(acc[q]>=L){var l0=acc[q-1],l1=acc[q],f=(l1>l0)?(L-l0)/(l1-l0):0;return (q-1+f)/N;}}return 1;}
    var run=(aL-total)/2,out=[];
    for(var i=0;i<widths.length;i++){var wc=widths[i],t=tAt(run+wc/2),pp=bez(t),dd=dbez(t);out.push({x:pp.x,y:pp.y,a:Math.atan2(dd.y,dd.x)});run+=wc;}
    return out;
  }
  function mtArcRun(e,txt,fs,measure){
    var chars=mtEffectText(e,txt).replace(/\n/g,' ').split(''), glyphs=[], widths=[], total=0;
    chars.forEach(function(c){var w=measure(c);glyphs.push(w);widths.push(w+(e.ls||0)*fs);total+=w+(e.ls||0)*fs;});
    return {chars:chars,glyphs:glyphs,widths:widths,pos:total>0?_arcLayout(widths,total,fs,clamp(+e.curve,-100,100)/100):[],total:total};
  }
  function mtCanvasArc(mc,e,txt,fpx){
    var old=mc.letterSpacing;try{mc.letterSpacing='0px';}catch(_){}
    var run=mtArcRun(e,txt,fpx,function(c){return mc.measureText(c).width;});
    try{mc.letterSpacing=old||'0px';}catch(_){}return run;
  }
  function mtDrawCurved(mc,e,txt,fpx,cx,cy,syn){
    var old=mc.letterSpacing,run=mtCanvasArc(mc,e,txt,fpx);
    mc.save();try{
      try{mc.letterSpacing='0px';}catch(_){}mc.textAlign='center';mc.textBaseline='middle';
      run.pos.forEach(function(p,i){mc.save();mc.translate(cx+p.x,cy+p.y);mc.rotate(p.a);
        if(syn>0){mc.lineJoin='round';mc.miterLimit=2;mc.lineWidth=syn;mc.strokeStyle='#000';mc.strokeText(run.chars[i],0,0);}
        mc.fillText(run.chars[i],0,0);mc.restore();});
    }finally{mc.restore();try{mc.letterSpacing=old||'0px';}catch(_){}}
  }
  /* Géométrie du doigt et du curseur : les coordonnées retournées suivent
     aussi l’arc et la rotation, sans modifier le texte saisi ni ses indices. */
  function mtTextGeometry(mc,e,fpx,cx,cy){
    var carets=[],boxes=[],rot=normRot(e.rot)*Math.PI/180;
    function point(x,y,a){return {x:cx+x*Math.cos(rot)-y*Math.sin(rot),y:cy+x*Math.sin(rot)+y*Math.cos(rot),a:(a||0)+rot};}
    function box(x,y,w,a){var co=Math.cos(a||0),si=Math.sin(a||0);[-1,1].forEach(function(sx){[-1,1].forEach(function(sy){boxes.push(point(x+sx*w/2*co-sy*fpx*.56*si,y+sx*w/2*si+sy*fpx*.56*co,0));});});}
    if(mtHasCurve(e)){
      var run=mtCanvasArc(mc,e,String(e.text||''),fpx),raw=String(e.text||'');
      function edge(n){if(!run.pos.length)return point(0,0,0);var i=Math.min(n,run.pos.length-1),p=run.pos[i],off=n<run.pos.length?-run.glyphs[i]/2:run.glyphs[i]/2;return point(p.x+off*Math.cos(p.a),p.y+off*Math.sin(p.a),p.a);}
      for(var k=0;k<=raw.length;k++)carets.push(edge(mtEffectText(e,raw.slice(0,k)).length));
      run.pos.forEach(function(p,i){box(p.x,p.y,run.glyphs[i],p.a);});
    }else{
      var lines=mtTextLines(e),rawLines=String(e.text||'').split('\n'),lh=fpx*MT_LH;
      lines.forEach(function(ln,i){var w=mc.measureText(ln).width,x0=e.align==='left'?0:(e.align==='right'?-w:-w/2),y=(i-(lines.length-1)/2)*lh;
        box(x0+w/2,y,w,0);for(var k=0;k<=rawLines[i].length;k++)carets.push(point(x0+mc.measureText(mtEffectText(e,rawLines[i].slice(0,k))).width,y,0));});
    }
    if(!boxes.length)boxes=[point(0,-fpx*.56,0),point(0,fpx*.56,0)];
    var xs=boxes.map(function(p){return p.x;}),ys=boxes.map(function(p){return p.y;});
    return {carets:carets,points:boxes,bounds:{left:Math.min.apply(null,xs),right:Math.max.apply(null,xs),top:Math.min.apply(null,ys),bottom:Math.max.apply(null,ys)}};
  }

  /* Réduit ensemble la courbe et les glyphes uniquement si leur enveloppe
     transformée dépasse la forme. Les six demi-plans sont l’hexagone réel,
     avec la même marge intérieure de 4 % que le fit du texte droit.
     Une seule mesure : toute cette géométrie est proportionnelle à la taille. */
  function mtFitEffectText(el,txt,x,y,font,weight,size,shapeKey){
    var sh=SHAPES[shapeKey]||SHAPES.hexa,W=MEASW,H=W*sh.hcm/sh.wcm,s=size;
    var planes=sh.cls==='sq'?[[1,0,.985],[-1,0,-.015],[0,1,.985],[0,-1,-.015]]:
      [[0,1,.98],[0,-1,-.02],[1,.5,1.23],[-1,-.5,-.27],[1,-.5,.73],[-1,.5,.23]];
    var probe=mtCopyEffects(el,{type:'text',text:txt,font:font,weight:weight,ls:el.ls||0,align:el.align});
    _measCx.save();try{
      _measCx.textAlign='center';_measCx.textBaseline='middle';
      {
        var px=sizeCqwFor(s,shapeKey)/100*W;
        _measCx.font=weight+' '+px+'px '+engraveCss(font,weight);
        try{_measCx.letterSpacing=(el.ls?el.ls*px:0)+'px';}catch(_){}
        var points=mtTextGeometry(_measCx,probe,px,x*W,y*H).points,k=1;
        points.forEach(function(p){planes.forEach(function(q){
          var available=q[2]-q[0]*x-q[1]*y,delta=q[0]*(p.x/W-x)+q[1]*(p.y/H-y);
          if(delta>0&&delta>available)k=Math.min(k,Math.max(0,available/delta));
        });});
        if(k>0&&k<1)s=s*k*.995;
      }
    }finally{_measCx.restore();}
    return Math.floor(s*10000)/10000;
  }
  function mtRequiresEffectSVG(src){return (src.els||[]).some(function(e){return normRot(e.rot)||(e.type==='text'&&(mtHasCurve(e)||e.smallcaps));});}

  /* ============================ GRAVURE ============================ */
  function paintEngraveLive(ctx,W,H,src){
    var els=src.els||[];
    if(!_maskCv){_maskCv=document.createElement('canvas');}
    if(_maskCv.width!==W||_maskCv.height!==H){_maskCv.width=W;_maskCv.height=H;}
    var mk=_maskCv,mc=mk.getContext('2d');mc.setTransform(1,0,0,1,0,0);mc.clearRect(0,0,W,H);
    try{mc.imageSmoothingQuality='high';}catch(_){}
    mc.textAlign='center';mc.textBaseline='middle';mc.fillStyle='#000';
    els.forEach(function(e){
      /* LABO Atelier mobile : un voile 0..1 par index recette eclaircit
         l'element (exemple en cours d'edition) sans toucher les autres */
      var _vo=0,_br=0; try{ if(window.__MTA_VOILE__&&e.__i!=null)_vo=+window.__MTA_VOILE__[e.__i]||0; if(window.__MTA_BRAISE__&&e.__i!=null)_br=+window.__MTA_BRAISE__[e.__i]||0; }catch(_){}
      mc.save();try{
      mc.globalAlpha=_vo?Math.max(.05,1-_vo):1;
      var cx=(e.x!=null?e.x:0.5)*W, cy=(e.y!=null?e.y:0.5)*H;
      var rot=normRot(e.rot);if(rot){mc.translate(cx,cy);mc.rotate(rot*Math.PI/180);cx=0;cy=0;}
      if(e.type==='text'){
        var f=fontById(e.font), fpx=sizeCqwFor(e.size,src.shape)/100*W;
        try{mc.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){}
        mc.font=(e.weight||600)+' '+fpx+'px '+engraveCss(e.font,e.weight||600);
        var lines=mtTextLines(e),lh=fpx*MT_LH,y0=cy-(lines.length-1)*lh/2;
        var ax=(e.align==='left'?'left':(e.align==='right'?'right':'center'));mc.textAlign=ax;
        var _syn=mtSyntheticStroke(e.font,e.weight||600,fpx);
        function drawText(stroke){
          if(mtHasCurve(e)){mtDrawCurved(mc,e,String(e.text||''),fpx,cx,cy,stroke);return;}
          lines.forEach(function(ln,li){
            if(stroke>0){mc.save();mc.lineJoin='round';mc.miterLimit=2;mc.lineWidth=stroke;mc.strokeStyle='#000';mc.strokeText(ln,cx,y0+li*lh);mc.restore();}
            mc.fillText(ln,cx,y0+li*lh);
          });
        }
        drawText(_syn);
        /* Atelier mobile : la braise suit le même arc que la gravure. */
        if(_br>0){var _ga=mc.globalAlpha;mc.globalAlpha=Math.min(1,_ga*_br*.5);drawText(0);mc.globalAlpha=_ga;}
        mc.textAlign='center';
      } else {
        var slot=getLogoImg(e.icon); if(!slot.ready||!slot.img||!slot.img.naturalWidth)return;
        var bx=slot.box, s=sizeCqwFor(e.size,src.shape)/100*W, k=Math.min(s/bx.w,s/bx.h), dw=bx.w*k, dh=bx.h*k;
        mc.drawImage(slot.img,cx-dw/2,cy-dh/2,dw,dh);
        /* LABO Atelier : braise des motifs — plus sombre un instant */
        if(_br>0){ var _gai=mc.globalAlpha; mc.globalAlpha=Math.min(1,_gai*_br*.5); mc.drawImage(slot.img,cx-dw/2,cy-dh/2,dw,dh); mc.globalAlpha=_gai; }
      }
      }finally{mc.restore();}
    });
    mc.globalAlpha=1;
    /* LABO Atelier : curseur GRAVE clignotant au bout du champ en cours —
       __MTA_CURSEUR__ = {i, on, x, y, size} ; l'element cuit fait foi,
       les coordonnees recette servent de repli quand le champ est vide */
    try{
      var CU=window.__MTA_CURSEUR__;
      if(CU&&CU.on){
        var ce=null,_ci; for(_ci=0;_ci<els.length;_ci++){ if(els[_ci].__i===CU.i&&els[_ci].type==='text'){ce=els[_ci];break;} }
        var csize=(ce?ce.size:CU.size)||6, cfpx=sizeCqwFor(csize,src.shape)/100*W;
        var cx2,cy2;
        if(ce){
          var cfont=ce.font||'cormorant', cwg=ce.weight||600;
          var clines=(ce.lines&&ce.lines.length)?ce.lines:String(ce.text||'').split('\n');
          var clh=cfpx*MT_LH, cy0=(ce.y!=null?ce.y:0.5)*H-(clines.length-1)*clh/2;
          cy2=cy0+(clines.length-1)*clh;
          mc.font=cwg+' '+cfpx+'px '+engraveCss(cfont,cwg);
          var clast=clines[clines.length-1]||'';
          var ctw=mc.measureText(clast).width;
          var cax=(ce.align==='left'?'left':(ce.align==='right'?'right':'center'));
          var cccx=(ce.x!=null?ce.x:0.5)*W;
          if(CU.gauche){
            /* mode exemple : le curseur attend DEVANT le texte — on ecrit
               a sa place, on ne le supprime pas */
            cx2=(cax==='left')?cccx:(cax==='right'?cccx-ctw:cccx-ctw/2);
            cx2-=Math.max(2,cfpx*0.12);
          } else {
            cx2=(cax==='left')?cccx+ctw:(cax==='right'?cccx:cccx+ctw/2);
            cx2+=Math.max(2,cfpx*0.08);
          }
          /* LABO Atelier : position DANS le texte (le doigt a pose le
             curseur, ou il a bouge dans le champ) — pos = index dans la
             valeur tapee, les lignes cuites servent de carte */
          if(CU.pos!=null&&!CU.gauche){
            var _p=Math.max(0,CU.pos|0),_cli=0,_ccol=_p;
            for(_cli=0;_cli<clines.length;_cli++){ if(_ccol<=(clines[_cli]||'').length)break; _ccol-=(clines[_cli]||'').length+1; }
            if(_cli>=clines.length){ _cli=clines.length-1; _ccol=(clines[_cli]||'').length; }
            cy2=cy0+_cli*clh;
            var _cln=clines[_cli]||'',_clw=mc.measureText(_cln).width;
            var _clx0=(cax==='left')?cccx:(cax==='right'?cccx-_clw:cccx-_clw/2);
            cx2=_clx0+mc.measureText(_cln.slice(0,_ccol)).width+Math.max(1,cfpx*0.02);
            /* espaces en fin de frappe : la gravure les taille (trim) mais le
               doigt, lui, a bien avance — le curseur suit les espaces en
               attente, sinon il semble fige et trompe le client */
            var _ctot=0,_ck; for(_ck=0;_ck<clines.length;_ck++)_ctot+=(clines[_ck]||'').length;
            _ctot+=clines.length-1;
            if(_p>_ctot){ cx2+=mc.measureText(' ').width*Math.min(_p-_ctot,8); }
          }
        } else {
          cx2=(CU.x!=null?CU.x:0.5)*W; cy2=(CU.y!=null?CU.y:0.5)*H;
        }
        var caretAngle=0;
        if(ce&&(mtHasCurve(ce)||normRot(ce.rot)||ce.smallcaps)){
          mc.font=(ce.weight||600)+' '+cfpx+'px '+engraveCss(ce.font,ce.weight||600);
          try{mc.letterSpacing=(ce.ls?ce.ls*cfpx:0)+'px';}catch(_){}
          var cg=mtTextGeometry(mc,ce,cfpx,(ce.x!=null?ce.x:.5)*W,(ce.y!=null?ce.y:.5)*H);
          var cp=CU.gauche?0:(CU.pos!=null?Math.max(0,CU.pos|0):cg.carets.length-1);
          var cpt=cg.carets[Math.min(cp,cg.carets.length-1)];
          if(cpt){cx2=cpt.x;cy2=cpt.y;caretAngle=cpt.a;}
        }
        mc.save();mc.translate(cx2,cy2);mc.rotate(caretAngle);cx2=0;cy2=0;
        mc.globalAlpha=0.9;
        mc.fillRect(cx2-Math.max(1,cfpx*0.035), cy2-cfpx*0.42, Math.max(2,cfpx*0.07), cfpx*0.7);
        mc.restore();mc.globalAlpha=1;
      }
    }catch(_){}
    try{mc.letterSpacing='0px';}catch(_){}
    /* gravure laser calée sur la photo produit : brun chaud doux, fusionné à la terre cuite
       (multiply), bords adoucis — AUCUN relief/contour artificiel. Après fusion sur la terre
       cuite, le cœur du trait retombe sur ~(108,47,19), la couleur mesurée sur la photo. */
    /* gravure calée sur la photo produit, trait un peu plus gras et plus dense :
       1) dilatation douce du masque (~0,9 px) -> trait légèrement plus épais (plus "gras")
       2) flou réduit + opacité 0,90 -> brun plus dense, moins délavé
       couleur #6f5331 : après fusion multiply sur la terre cuite, le cœur retombe vers ~(100,42,16),
       un cran plus soutenu que la photo (108,47,19) pour compenser la dispersion du flou. */
    /* CALAGE SUR LA VRAIE PHOTO — 3 réglages :
       GRAS  = épaisseur ajoutée au trait (0 = poids naturel de la police, le plus fin ; 1 = ancien rendu épais)
       BLURK = douceur des bords (plus petit = bords plus nets, trait plus dense)
       ALPHA = densité/opacité de la gravure (0.90 = dense ; baisser = plus clair) */
    var GRAS=0.0, BLURK=0.0004, ALPHA=1.0;
    var _dil=document.createElement('canvas'); _dil.width=mk.width; _dil.height=mk.height;
    var _dc=_dil.getContext('2d'); _dc.drawImage(mk,0,0);
    var _r=W*0.0012*GRAS;
    if(_r>0.12){
      var _dd=[[_r,0],[-_r,0],[0,_r],[0,-_r],[_r*0.7,_r*0.7],[-_r*0.7,_r*0.7],[_r*0.7,-_r*0.7],[-_r*0.7,-_r*0.7]];
      for(var _i=0;_i<_dd.length;_i++){ _dc.drawImage(mk,_dd[_i][0],_dd[_i][1]); }
    }
    var _sf=null; try{_sf=ctx.filter;}catch(_){}
    try{ if('filter' in ctx){ ctx.filter='blur('+Math.max(.3,W*BLURK).toFixed(2)+'px)'; } }catch(_){}
    ctx.globalCompositeOperation='multiply'; ctx.globalAlpha=ALPHA; ctx.drawImage(tintMaskC(_dil,'#6f5331'),0,0);
    try{ ctx.filter=_sf||'none'; }catch(_){}
    ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';
  }
  function renderTileTo(cv,box,src){
    if(!cv||!box)return;
    var rect=box.getBoundingClientRect(),Wl=Math.round(rect.width),Hl=Math.round(rect.height);
    if(Wl<2||Hl<2)return;
    var dpr=Math.min(3,window.devicePixelRatio||1),W=Math.round(Wl*dpr),H=Math.round(Hl*dpr);
    if(cv.width!==W||cv.height!==H){cv.width=W;cv.height=H;}
    var ctx=cv.getContext('2d');ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,W,H);
    ctx.imageSmoothingEnabled=true;try{ctx.imageSmoothingQuality='high';}catch(_){}
    var sq=(SHAPES[src.shape]||SHAPES.hexa).cls==='sq', bg=getBgImg(sq);
    var bw=bg.img&&(bg.img.naturalWidth||bg.img.width);
    if(bw){
      if(sq){
        /* carre : photo COMPLETE (fond blanc conserve, comme l'hexagone) + gravure calee sur la
           bbox reelle du carreau (le carreau est insere dans la photo -> pas mappe sur tout le cadre) */
        var rcf2=containRect(bg.img,W,H); drawContain(ctx,bg.img,W,H);
        var sb=squareTileBox(bg.img);
        var sgx=rcf2.x+sb.x0*rcf2.w, sgy=rcf2.y+sb.y0*rcf2.h, sgw=(sb.x1-sb.x0)*rcf2.w, sgh=(sb.y1-sb.y0)*rcf2.h;
        var seng=document.createElement('canvas'); seng.width=W; seng.height=H;
        var sec=seng.getContext('2d'); sec.save(); sec.translate(sgx,sgy); paintEngraveLive(sec,sgw,sgh,src); sec.restore();
        ctx.globalCompositeOperation='multiply'; ctx.drawImage(seng,0,0); ctx.globalCompositeOperation='source-over';
      } else if(bg.full){
        /* FOND = photo complète cleantomette (fond blanc + ombre douce réelle), sans détourage */
        var rcf=containRect(bg.full,W,H);
        ctx.drawImage(bg.full,rcf.x,rcf.y,rcf.w,rcf.h);
        var hgx=rcf.x+CLEAN_HEX.x0*rcf.w, hgy=rcf.y+CLEAN_HEX.y0*rcf.h;
        var hgw=(CLEAN_HEX.x1-CLEAN_HEX.x0)*rcf.w, hgh=(CLEAN_HEX.y1-CLEAN_HEX.y0)*rcf.h;
        var eng=document.createElement('canvas'); eng.width=W; eng.height=H;
        var ec=eng.getContext('2d');
        ec.save(); ec.translate(hgx,hgy); paintEngraveLive(ec,hgw,hgh,src); ec.restore();
        if(bg.mask){ ec.globalCompositeOperation='destination-in'; ec.drawImage(bg.mask,0,0,bg.mask.width,bg.mask.height,hgx,hgy,hgw,hgh); ec.globalCompositeOperation='source-over'; }
        ctx.globalCompositeOperation='multiply'; ctx.drawImage(eng,0,0); ctx.globalCompositeOperation='source-over';
      } else {
        drawContain(ctx,bg.img,W,H);
        paintEngraveLive(ctx,W,H,src);
        ctx.globalCompositeOperation='destination-in';
        if(bg.mask){var rc=containRect(bg.img,W,H);ctx.drawImage(bg.mask,0,0,bg.mask.width,bg.mask.height,rc.x,rc.y,rc.w,rc.h);}else{hexPath(ctx,W,H);ctx.fillStyle='#000';ctx.fill();}
      }
      ctx.globalCompositeOperation='source-over';
    } else {
      ctx.save();shapePathLive(ctx,sq,W,H);ctx.clip();ctx.fillStyle='#bf6238';ctx.fillRect(0,0,W,H);paintEngraveLive(ctx,W,H,src);ctx.restore();
    }
  }
  function drawLive(){renderTileTo($('mtpCanvas'),$('mtpTile'),state);}
  function scheduleLive(){if(_raf)return;_raf=requestAnimationFrame(function(){_raf=0;try{drawLive();}catch(e){}});}
  function initRO(){if(_ro||!window.ResizeObserver)return;var box=$('mtpTile');if(!box)return;_ro=new ResizeObserver(function(){scheduleLive();});_ro.observe(box);}

  function holeCenters(shape){
    var sh=SHAPES[shape];
    if(sh.cls==='sq'){return [{x:1.5/sh.wcm,y:1.5/sh.hcm},{x:1-1.5/sh.wcm,y:1.5/sh.hcm}];}
    return [{x:0.5,y:1.5/sh.hcm}];
  }
  function applyHole(){
    var wrap=$('mtpTile'); var olds=wrap.querySelectorAll('.mtp-hole-window');
    for(var k=0;k<olds.length;k++){if(olds[k].parentNode)olds[k].parentNode.removeChild(olds[k]);}
    if(!state.hole)return;
    var sh=SHAPES[state.shape], centers=holeCenters(state.shape);
    /* LABO Atelier : les centres de trous vivent dans la SOUS-BOITE de la
       tomette (CLEAN_HEX / bbox carre), pas dans le cadre entier — meme
       projection que les zones et le curseur. */
    var m={x0:0,y0:0,kx:1,ky:1};
    try{ if(window.__MTA_CARTE__) m=__MTA_CARTE__(); }catch(e){}
    for(var i=0;i<centers.length;i++){
      var d=document.createElement('div');d.className='mtp-hole-window';
      d.style.width=(HOLE_DIAM_CM/sh.wcm*100*m.kx)+'%';
      d.style.left=((m.x0+centers[i].x*m.kx)*100)+'%'; d.style.top=((m.y0+centers[i].y*m.ky)*100)+'%';
      wrap.appendChild(d);
    }
  }

  /* ============================ EXPORT PNG ============================ */
  /* 07/10/2026 : l'aperçu PNG (_Aperçu : vignette du panier, e-mails, admin) ne montrait pas le
     trou de suspension, alors que l'aperçu en direct (.mtp-hole-window) et le SVG laser l'ont.
     Même rendu que .mtp-hole-window : disque gris clair, ombre intérieure en haut, fin liseré.
     box = boîte de la tomette dans l'image (mêmes fractions que holeCenters / applyHole). */
  function paintHolesPNG(ctx,box,src){
    if(!src||!src.hole||!box||!box.w||!box.h)return;
    var sh=SHAPES[src.shape]||SHAPES.hexa, centers=holeCenters(src.shape);
    var r=(HOLE_DIAM_CM/sh.wcm)*box.w/2;
    for(var i=0;i<centers.length;i++){
      var cx=box.x+centers[i].x*box.w, cy=box.y+centers[i].y*box.h;
      ctx.save();
      ctx.beginPath();ctx.arc(cx,cy,r,0,Math.PI*2);ctx.closePath();
      var g=ctx.createRadialGradient(cx,cy-r*0.24,0,cx,cy,r);g.addColorStop(0,'#F4F4F4');g.addColorStop(1,'#E3E3E3');
      ctx.fillStyle=g;ctx.fill();
      ctx.clip();
      ctx.shadowColor='rgba(13,13,13,.55)';ctx.shadowBlur=Math.max(1,r*0.35);ctx.shadowOffsetY=Math.max(1,r*0.18);
      ctx.beginPath();ctx.arc(cx,cy,r*1.6,0,Math.PI*2);ctx.lineWidth=r*1.2;ctx.strokeStyle='#000';ctx.stroke();
      ctx.restore();
      ctx.save();ctx.beginPath();ctx.arc(cx,cy,r,0,Math.PI*2);ctx.lineWidth=Math.max(1,r*0.06);ctx.strokeStyle='rgba(13,13,13,.12)';ctx.stroke();ctx.restore();
    }
  }
  function renderPNG(src,cb){
    var sh=SHAPES[src.shape]||SHAPES.hexa, sq=sh.cls==='sq', W=1200, H=Math.round(W*(sh.hcm/sh.wcm));
    function paint(ctx,bgImg){
      var hx=(bgImg&&!sq)?buildCleanHex(bgImg):null, hr=hx?containRect(hx.tex,W,H):null;
      if(sq&&bgImg){
        /* carre : photo COMPLETE (fond blanc conserve) + gravure calee sur la bbox du carreau */
        drawContain(ctx,bgImg,W,H);
        var _rcf=containRect(bgImg,W,H), _sb=squareTileBox(bgImg);
        var _sgx=_rcf.x+_sb.x0*_rcf.w, _sgy=_rcf.y+_sb.y0*_rcf.h, _sgw=(_sb.x1-_sb.x0)*_rcf.w, _sgh=(_sb.y1-_sb.y0)*_rcf.h;
        var _seng=document.createElement('canvas'); _seng.width=W; _seng.height=H;
        var _sec=_seng.getContext('2d'); _sec.save(); _sec.translate(_sgx,_sgy); paintEngraveLive(_sec,_sgw,_sgh,src); _sec.restore();
        ctx.globalCompositeOperation='multiply'; ctx.drawImage(_seng,0,0); ctx.globalCompositeOperation='source-over';
        paintHolesPNG(ctx,{x:_sgx,y:_sgy,w:_sgw,h:_sgh},src);
        return;
      }
      if(bgImg){
        ctx.drawImage(hx.tex,0,0,hx.tex.width,hx.tex.height,hr.x,hr.y,hr.w,hr.h);
      }else{ctx.fillStyle='#bf6238';if(sq){roundRectPath(ctx,0,0,W,H,Math.round(W*0.03));}else{hexPath(ctx,W,H);}ctx.fill();}
      paintEngraveLive(ctx,W,H,src);
      ctx.globalCompositeOperation='destination-in';
      if(bgImg){
        ctx.drawImage(hx.mask,0,0,hx.mask.width,hx.mask.height,hr.x,hr.y,hr.w,hr.h);
      } else {ctx.fillStyle='#000';if(sq){roundRectPath(ctx,0,0,W,H,Math.round(W*0.03));}else{hexPath(ctx,W,H);}ctx.fill();}
      ctx.globalCompositeOperation='source-over';
      paintHolesPNG(ctx,{x:0,y:0,w:W,h:H},src); /* même repère que paintEngraveLive(ctx,W,H) et le SVG laser */
    }
    function build(useBg){
      function finish(bgImg){var cv=document.createElement('canvas');cv.width=W;cv.height=H;var ctx=cv.getContext('2d');paint(ctx,bgImg);var url=null;try{url=cv.toDataURL('image/png');}catch(e){url=null;}if(!url&&useBg){build(false);return;}cb(url);}
      if(useBg){var bg=new Image();bg.crossOrigin='anonymous';bg.onload=function(){finish(bg);};bg.onerror=function(){build(false);};bg.src=photoUrl(sq);}else{finish(null);}
    }
    var ids=(src.els||[]).filter(function(e){return e.type==='icon';}).map(function(e){return e.icon;});
    var slots=ids.map(getLogoImg);
    function allReady(){for(var i=0;i<slots.length;i++){if(!slots[i].ready)return false;}return true;}
    if(allReady())build(true); else { var iv=setInterval(function(){if(allReady()){clearInterval(iv);build(true);}},60); setTimeout(function(){clearInterval(iv);build(true);},2200); }
  }

  /* ============================ EXPORT SVG LASER ============================ */
  var OPENTYPE_URL='https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js';
  /* Table police -> fichier TTF (miroir Google), IDENTIQUE au configurateur complet : canvas et
     SVG laser tracent depuis exactement la meme source. Toute police manquante ici -> repli <text>
     (police substituee cote machine) = a eviter. Superset du configurateur + polices manuscrites du guide. */
  /* Polices variables instanciees en STATIQUE au poids reel : opentype.js n'applique pas
     l'axe wght (il sort le poids par defaut, trop fin -> SVG plus leger que l'apercu).
     On charge donc un fichier fige au bon poids, utilise a l'IDENTIQUE par le canvas ET le
     SVG laser (satisfait ou regrave). Servi par @fontsource / jsDelivr (aucun upload) :
     Ajouter une entree si une police variable
     est utilisee a un poids != son defaut (Cormorant defaut=300, DM Sans defaut=400). */
  /* INDEXE PAR FAMILLE + GRAISSE. Avant, la cle etait la seule famille : une tomette
     utilisant Montserrat en 400 ET en 800 n'obtenait qu'un seul fichier — le dernier
     enregistre — et les deux textes sortaient gravés dans la meme graisse. */
  var MTE_STATIC={
    'Cormorant Garamond|600':{url:"https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond@5/files/cormorant-garamond-latin-600-normal.woff",weight:600,verified:true},
    'DM Sans|600':{url:"https://cdn.jsdelivr.net/npm/@fontsource/dm-sans@5/files/dm-sans-latin-600-normal.woff",weight:600,verified:true}
  };
  function mtStatKey(fam,w){ return String(fam)+'|'+(parseInt(w,10)||400); }
  function mtStat(fam,w){ return (typeof MTE_STATIC!=='undefined')?MTE_STATIC[mtStatKey(fam,w)]:null; }
  /* Familles Google VARIABLES : poids rendu PAR DEFAUT par opentype.js (axe wght non applique). */
  var MTE_VARDEF={'Cormorant Garamond':300,'DM Sans':400,'Caveat':400,'Cinzel':400,'Inter':400,'Dancing Script':400,'Playfair Display':400,'EB Garamond':400};
  /* liste des graisses reellement declarees par la famille ("400;700" -> [400,700]) */
  function mtDeclaredWeights(fr){
    var a=String((fr&&fr.weights)||'400').match(/\d+/g)||['400'];
    return a.map(function(x){return parseInt(x,10)||400;});
  }
  function mtNearestDeclaredWeight(fr,w){
    var list=mtDeclaredWeights(fr); if(list.indexOf(w)>=0)return w;
    var best=list[0]||400,d=Math.abs(best-w);
    for(var i=1;i<list.length;i++){ var nd=Math.abs(list[i]-w); if(nd<d){d=nd;best=list[i];} }
    return best;
  }
  /* ============== GRAISSE SIMULEE (portee du configurateur expert) ==============
     Toutes les familles n'existent pas dans toutes les graisses : une police
     importee (Ocean, Sud, Betty...) n'a qu'UN seul fichier, en 400. Demander un
     600 ne charge rien de plus gras -- le configurateur expert compense en
     epaississant le trace (mteSyntheticStroke / mteSvgInk). Sans equivalent ici,
     le meme texte ressortait plus fin dans l'apercu guide et dans le SVG laser.
     Le fichier reellement utilise est soit le statique @fontsource fige au bon
     poids (MTE_STATIC), soit le poids declare le plus proche ; la difference
     restante est comblee au trait, a l'ecran ET a la gravure. */
  function mtFaceWeightFor(fontId,w){
    var fr=FONTREG[fontId]||{}, fam=famOf(fontId);
    var stat=mtStat(fam,w);
    if(stat&&stat.weight)return stat.weight;
    return mtNearestDeclaredWeight(fr,w);
  }
  function mtSyntheticStroke(fontId,w,fontSize){
    var d=(w||400)-mtFaceWeightFor(fontId,w||400);
    return d>0?(fontSize*0.055*(d/400)):0;     /* meme formule que l'expert */
  }
  function mtSvgInk(fontId,w,fontSize){
    var sw=mtSyntheticStroke(fontId,w,fontSize);
    return sw>0?(' fill="#000" stroke="#000" stroke-width="'+sw.toFixed(3)+'" stroke-linejoin="round" paint-order="stroke fill"'):' fill="#000"';
  }
  function mteSlug(fam){return String(fam||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  /* Statique par poids via @fontsource (woff, lisible opentype.js + canvas) -> meme graisse des deux cotes. */
  function fontsourceWoff(fam,weight){var sl=mteSlug(fam);if(!sl)return null;return 'https://cdn.jsdelivr.net/npm/@fontsource/'+sl+'@5/files/'+sl+'-latin-'+(weight||400)+'-normal.woff';}
  var _mtePrepSig=null;
  /* (1) enregistre le statique au bon poids pour les variables Google hors poids par defaut ;
     (2) PRECHAUFFE opentype pour toutes les polices avant la generation du SVG (tue la course -> <text>). */
  function mtePrepFonts(els){
    try{
      els=els||[];
      els.forEach(function(e){
        if(!e||e.type!=='text')return;
        var fr=FONTREG[e.font]||{}, fam=famOf(e.font), w=e.weight||cDefWeight(e.font);
        /* Une famille Google doit etre chargee au POIDS REEL demande par la recette.
           opentype.js n'applique pas l'axe wght, et css2 sans :wght@ ne sert que le 400 :
           sans fichier statique au bon poids, l'apercu guide, l'apercu du configurateur
           expert et le SVG envoye au laser divergent.
           On ne se limite plus a MTE_VARDEF (8 familles ecrites en dur) : TOUTE police
           Google demandee a un poids different de son defaut recoit son fichier
           @fontsource fige, exactement comme le fait deja le configurateur expert. */
        var _sk=mtStatKey(fam,w);
        if(MTE_STATIC[_sk]&&MTE_STATIC[_sk].verified)return;
        var _isG=(fr.source==='google')||(MTE_VARDEF[fam]!=null)||(!fr.source&&!fr.url&&!fr.ttf);
        var _def=(MTE_VARDEF[fam]!=null)?MTE_VARDEF[fam]:400;
        /* Le poids doit EXISTER dans la famille. Amatic SC ne declare que 400 et
           700 : demander un 600 a @fontsource renvoie un 404, la regle @font-face
           echoue, et TOUT le texte retombe sur la police de repli (serif).
           On se rabat donc sur le poids declare le plus proche -- c'est ce que
           fait deja mteFontSpec() dans le configurateur expert. */
        var _wOk=mtNearestDeclaredWeight(fr,w);
        if(_isG){
          /* AUSSI au poids par defaut : sinon engraveTtfUrl retombe sur le
             TTF variable complet (Caveat 207 Ko, Amatic 79 Ko...) la ou le
             woff statique @fontsource (~35 Ko) rend le meme dessin — et
             l'apercu comme le laser continuent de partager LE MEME fichier */
          var u=fontsourceWoff(fam,_wOk); if(u)MTE_STATIC[_sk]={url:u,weight:_wOk};
        }else if(MTE_STATIC[_sk]&&!MTE_STATIC[_sk].verified){ delete MTE_STATIC[_sk]; }
      });
      var sig=els.map(function(e){return e&&e.type==='text'?(famOf(e.font)+'|'+(e.weight||cDefWeight(e.font))):'';}).join(',');
      /* les TTF opentype (contours laser) ne servent qu'a GENERER le fichier
         de gravure : on ne les precharge que si une personnalisation existe
         (parcours mobile actif, ou une vraie valeur saisie/reprise). Le
         visiteur qui ne fait que lire la fiche economise ~300 Ko + opentype. */
      var _grave=false;
      try{
        _grave = document.documentElement.classList.contains('mta-parcours')
          || (state && state.values && Object.keys(state.values).some(function(k){ return String(state.values[k]||'').trim(); }));
      }catch(_){}
      if(sig!==_mtePrepSig && _grave){ _mtePrepSig=sig; var seen={};
        els.forEach(function(e){ if(!e||e.type!=='text')return; var _w=e.weight||cDefWeight(e.font), _k=e.font+'|'+_w;
          if(seen[_k])return; seen[_k]=1; try{loadOTFont(e.font,_w,function(){});}catch(_){} });
      }
    }catch(_){}
  }
  var FONT_TTF={
    'Great Vibes':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/greatvibes/GreatVibes-Regular.ttf',
    'Allura':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/allura/Allura-Regular.ttf',
    'Parisienne':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/parisienne/Parisienne-Regular.ttf',
    'Sacramento':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/sacramento/Sacramento-Regular.ttf',
    'Dancing Script':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/dancingscript/DancingScript%5Bwght%5D.ttf',
    'Pacifico':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/pacifico/Pacifico-Regular.ttf',
    'Caveat':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/caveat/Caveat%5Bwght%5D.ttf',
    'Cinzel':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/cinzel/Cinzel%5Bwght%5D.ttf',
    'Marcellus':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/marcellus/Marcellus-Regular.ttf',
    'Amatic SC':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/amaticsc/AmaticSC-Regular.ttf',
    'Yellowtail':'https://cdn.jsdelivr.net/gh/google/fonts@main/apache/yellowtail/Yellowtail-Regular.ttf',
    'Inter':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/inter/Inter%5Bopsz,wght%5D.ttf',
    'Pinyon Script':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/pinyonscript/PinyonScript-Regular.ttf',
    'Cormorant Garamond':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/cormorantgaramond/CormorantGaramond%5Bwght%5D.ttf',
    'DM Sans':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/dmsans/DMSans%5Bopsz,wght%5D.ttf',
    'Reenie Beanie':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/reeniebeanie/ReenieBeanie.ttf',
    'Indie Flower':'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/indieflower/IndieFlower-Regular.ttf'
  };
  var _otReady=null,_fontCache={};
  function ensureOpentype(cb){
    if(window.opentype){cb(true);return;}
    if(_otReady){_otReady.push(cb);return;}
    _otReady=[cb];var fired=false;
    function flush(ok){if(fired)return;fired=true;var q=_otReady;_otReady=null;for(var i=0;i<q.length;i++)q[i](ok&&!!window.opentype);}
    var sc=document.createElement('script');sc.src=OPENTYPE_URL;sc.onload=function(){flush(true);};sc.onerror=function(){flush(false);};document.head.appendChild(sc);
    setTimeout(function(){flush(!!window.opentype);},7000);
  }
  function loadOTFont(fontId,w,cb){
    if(typeof w==='function'){cb=w;w=null;}          /* ancienne signature toleree */
    w=w||cDefWeight(fontId);
    var fam=famOf(fontId), fr=FONTREG[fontId];
    var stat=mtStat(fam,w);
    var url=engraveTtfUrl(fontId,w);
    /* repli si le fichier statique n'est pas deverse dans les assets (evite le fallback <text>) */
    var fb=(typeof FONT_TTF!=='undefined'&&FONT_TTF[fam])||(fr&&(fr.ttf||fr.url))||null;
    if(!url){cb(null);return;}
    var ck=fam+'|'+(stat?stat.weight:('r'+w));
    if(_fontCache[ck]){cb(_fontCache[ck]);return;}
    ensureOpentype(function(ok){
      if(!ok||!window.opentype){cb(null);return;}
      function tryLoad(u,allowFb){
        try{opentype.load(u,function(err,font){
          if(err||!font){ if(allowFb&&fb&&fb!==u){tryLoad(fb,false);} else {cb(null);} }
          else{_fontCache[ck]=font;cb(font);}
        });}catch(e){ if(allowFb&&fb&&fb!==u){tryLoad(fb,false);} else {cb(null);} }
      }
      tryLoad(url,!!stat);
    });
  }
  /* Decalage de ligne de base, mesure en dessinant "Hg" au canvas : FAUX tant que la
     police n'est pas chargee, et mis en cache definitivement. On le vide donc a
     l'arrivee de chaque police (voir engraveFamFor). */
  var _mtMidCache={};
  function mtMidCacheClear(){ _mtMidCache={}; }
  function _mtLayCacheClearIfAny(){ try{ _mtePrepSig=null; }catch(e){} }
  /* La ligne de base est mesuree en dessinant "Hg" au canvas. Elle DOIT l'etre avec
     la police exactement utilisee pour les contours (l'alias MTE_ au bon poids), et
     non avec la famille CSS nue : le canvas prendrait alors le 400 par defaut, alors
     que le trace sort en 700. C'est ce qui laissait 0,2 a 0,7 mm d'ecart vertical
     entre le moteur guide et le configurateur expert. */
  function mtMidOff(cssFam,w){
    var _mk=cssFam+'|'+(w||400);
    if(_mtMidCache[_mk]!=null) return _mtMidCache[_mk];
    var off=0.34;
    try{
      var fz=200, cv=document.createElement('canvas'); cv.width=600; cv.height=600;
      var x=cv.getContext('2d'); x.textAlign='center'; x.fillStyle='#000'; x.font=(w||400)+' '+fz+'px '+cssFam;
      function inkMid(bl){
        x.clearRect(0,0,600,600); x.textBaseline=bl; x.fillText('Hg',300,300);
        var d=x.getImageData(0,0,600,600).data, t=-1, b=-1;
        for(var yy=0; yy<600; yy++){ var ba=yy*2400; for(var xx=0; xx<600; xx++){ if(d[ba+xx*4+3]>40){ if(t<0)t=yy; b=yy; break; } } }
        return t<0 ? null : (t+b)/2;
      }
      var m=inkMid('middle'), a=inkMid('alphabetic');
      if(m!=null && a!=null) off=(m-a)/fz;
    }catch(e){}
    _mtMidCache[_mk]=off; return off;
  }
  function buildLaserSVG(src,cb){
    var sh=SHAPES[src.shape]||SHAPES.hexa, Wmm=sh.wcm*10, Hmm=sh.hcm*10, els=src.els||[];
    /* une entree par COUPLE police+graisse : deux textes de la meme famille a des
       graisses differentes doivent charger deux fichiers distincts. */
    var fids={}; els.forEach(function(e){if(e.type==='text'){var _w=e.weight||cDefWeight(e.font);fids[e.font+'|'+_w]={fontId:e.font,weight:_w};}});
    var list=Object.keys(fids), fonts={}, left=list.length, done=false;
    function assemble(){
      if(done)return; done=true;
      var effectFontMissing=els.some(function(e){return e.type==='text'&&(mtHasCurve(e)||normRot(e.rot)||e.smallcaps)&&!fonts[e.font+'|'+(e.weight||cDefWeight(e.font))];});
      if(effectFontMissing){cb(null,{code:'FONT_LOAD_FAILED'});return;} /* jamais une gravure aplatie ou une autre police */
      var parts=[];
      if(sh.cls==='sq'){parts.push('<rect x="0" y="0" width="'+Wmm+'" height="'+Hmm+'" rx="'+(Wmm*0.03).toFixed(1)+'" fill="none" stroke="#00FF00" stroke-width="0.2"/>');}
      else{var pts=[[0.25*Wmm,0],[0.75*Wmm,0],[Wmm,0.5*Hmm],[0.75*Wmm,Hmm],[0.25*Wmm,Hmm],[0,0.5*Hmm]].map(function(p){return p[0].toFixed(2)+','+p[1].toFixed(2);}).join(' ');parts.push('<polygon points="'+pts+'" fill="none" stroke="#00FF00" stroke-width="0.2"/>');}
      if(src.hole){holeCenters(src.shape).forEach(function(c){parts.push('<circle cx="'+(c.x*Wmm).toFixed(2)+'" cy="'+(c.y*Hmm).toFixed(2)+'" r="'+(HOLE_DIAM_CM*10/2).toFixed(2)+'" fill="none" stroke="#00FF00" stroke-width="0.2"/>');});}
      els.forEach(function(e){
        var cx=(e.x!=null?e.x:0.5)*Wmm, cy=(e.y!=null?e.y:0.5)*Hmm,rot=normRot(e.rot),partStart=parts.length;
        if(e.type==='text'){
          var fs=(e.size||6.5)*1.2, font=fonts[e.font+'|'+(e.weight||cDefWeight(e.font))];
          var fr=fontById(e.font)||{};
          var _mw=e.weight||cDefWeight(e.font);
          var moff=(typeof fr.midOff==='number') ? fr.midOff : mtMidOff(engraveCss(e.font,_mw)||fr.css||famOf(e.font),_mw);
          /* EXACTEMENT les lignes calculees pour l'apercu : plus de split('\n')
             qui laissait passer une phrase entiere sur une seule ligne. */
          var lines=mtTextLines(e);
          var lh=fs*MT_LH, y0=cy-(lines.length-1)*lh/2;
          var _al=(e.align==='left'?'left':(e.align==='right'?'right':'center'));
          var _anchor=(_al==='left'?'start':(_al==='right'?'end':'middle'));
          var _ink=mtSvgInk(e.font,e.weight||600,fs);   /* graisse simulee, comme a l'ecran */
          if(mtHasCurve(e)){
            var run=mtArcRun(e,String(e.text||''),fs,function(c){return font.getAdvanceWidth(c,fs);});
            run.pos.forEach(function(p,i){var path=font.getPath(run.chars[i],-run.glyphs[i]/2,fs*moff,fs),d=path.toPathData(3);
              if(d)parts.push('<g transform="translate('+(cx+p.x).toFixed(2)+' '+(cy+p.y).toFixed(2)+') rotate('+(p.a*180/Math.PI).toFixed(2)+')"><path d="'+d+'"'+_ink+'/></g>');});
          }else lines.forEach(function(ln,li){
            var baseY=y0+li*lh+fs*moff;
            var _otopt={letterSpacing:(e.ls||0),kerning:true};
            if(font){
              var adv=font.getAdvanceWidth(ln,fs,_otopt);
              var _x=(_al==='left')?cx:((_al==='right')?(cx-adv):(cx-adv/2));   /* l'alignement etait ignore au SVG */
              var p=font.getPath(ln,_x,baseY,fs,_otopt),d=p.toPathData(3);
              if(d)parts.push('<path d="'+d+'"'+_ink+'/>');
            }
            else{parts.push('<text x="'+cx.toFixed(2)+'" y="'+baseY.toFixed(2)+'" font-family="'+esc(famOf(e.font))+'" font-size="'+fs.toFixed(2)+'" text-anchor="'+_anchor+'"'+_ink+'>'+esc(ln)+'</text>');}
          });
        }else{
          var s=(e.size||7.5)*1.2, raw=logoSvgRaw(e.icon).replace(/currentColor/g,'#000');
          var head=raw.match(/<svg\b([^>]*)>/i), attrs=head?head[1]:'', vbX=0,vbY=0,vbW=24,vbH=24;
          var vb=attrs.match(/viewBox\s*=\s*["']([-\d.\s]+)["']/);
          if(vb){var arr=vb[1].trim().split(/\s+/);if(arr.length===4){vbX=parseFloat(arr[0])||0;vbY=parseFloat(arr[1])||0;vbW=parseFloat(arr[2])||24;vbH=parseFloat(arr[3])||24;}}
          var inner=raw.replace(/^[\s\S]*?<svg[^>]*>/i,'').replace(/<\/svg>\s*$/i,'');
          var scl=s/Math.max(vbW,vbH);
          parts.push('<g transform="translate('+(cx-vbW*scl/2).toFixed(2)+' '+(cy-vbH*scl/2).toFixed(2)+') scale('+scl.toFixed(4)+') translate('+(-vbX).toFixed(2)+' '+(-vbY).toFixed(2)+')" fill="#000">'+inner+'</g>');
        }
      if(rot&&parts.length>partStart){var segment=parts.splice(partStart).join('');parts.push('<g transform="rotate('+rot+' '+cx.toFixed(2)+' '+cy.toFixed(2)+')">'+segment+'</g>');}
      });
      var faceCss='';
      list.forEach(function(k){var fr=FONTREG[fids[k].fontId];if(!fonts[k]&&fr&&(fr.url||fr.ttf)){faceCss+="@font-face{font-family:'"+(fr.family||fids[k].fontId)+"';src:url('"+(fr.url||fr.ttf)+"')}";}});
      var defs=faceCss?('<defs><style>'+faceCss+'</style></defs>'):'';
      cb('<svg xmlns="http://www.w3.org/2000/svg" width="'+Wmm+'mm" height="'+Hmm+'mm" viewBox="0 0 '+Wmm+' '+Hmm+'">'+defs+parts.join('')+'</svg>');
    }
    if(!list.length){assemble();return;}
    list.forEach(function(k){loadOTFont(fids[k].fontId,fids[k].weight,function(font){fonts[k]=font;if(--left<=0)assemble();});});
    setTimeout(assemble,9000);
  }

  /* ============================ LOGIQUE FAIRE-PART ============================ */
  var _measCv=document.createElement('canvas'), _measCx=_measCv.getContext('2d'), MEASW=1000;
  /* =====================================================================
     MISE EN PAGE DU TEXTE — fonction UNIQUE partagee par TOUS les rendus :
     apercu canvas, calque de gravure, et SVG envoye au laser.
     Regle : le texte reste sur les lignes voulues par l'admin -- SEULS les
     retours a la ligne saisis a la main coupent le texte. Si le bloc deborde
     (ligne trop large, ou hauteur superieure a la place disponible), on
     REDUIT la taille de police jusqu'a ce qu'il rentre. Jamais de coupure
     automatique : c'est la mise en page dessinee qui fait foi.
     Quatre passes au plus : reduire deplace le bloc dans l'hexagone, donc la
     largeur utile change et vaut la peine d'etre reevaluee.
     Avant, chaque rendu avait sa propre regle et le SVG laser n'en avait
     aucune (un simple split('\n')) : la gravure ne correspondait donc pas a
     ce que le client avait valide a l'ecran.
     Retourne {lines:[...], size:<taille finale>}.
     ===================================================================== */
  var MT_LH=1.12;                       /* interligne unique, identique partout */
  function mtLayoutText(txt,x,y,fontId,weight,size,ls,shapeKey,minSize){
    txt=String(txt==null?'':txt);
    var sh=SHAPES[shapeKey]||SHAPES.hexa, W=MEASW, H=W*(sh.hcm/sh.wcm);
    var s=size, lines=[txt], blockH=0;
    if(minSize==null)minSize=Math.max(3,size*0.5);
    for(var pass=0; pass<4; pass++){
      var fpx=sizeCqwFor(s,shapeKey)/100*W;
      _measCx.font=(weight||400)+' '+fpx+'px '+engraveCss(fontId,weight);
      try{ _measCx.letterSpacing=(ls?ls*fpx:0)+'px'; }catch(_){}
      /* largeur utile evaluee au BORD du bloc, la ou l'hexagone est le plus
         etroit dans la bande occupee par le texte : rien ne sort de la tomette. */
      var halfH=((blockH||fpx)*0.5)/H;
      var yEdge=clamp(y+(y>=0.5?halfH:-halfH),0,1);
      var maxW=usableWidthFrac(x,yEdge,shapeKey)*W;
      lines=txt.split('\n');                   /* AUCUNE coupure automatique */
      var wMax=0;
      for(var i=0;i<lines.length;i++){ var w=_measCx.measureText(lines[i]).width; if(w>wMax)wMax=w; }
      blockH=lines.length*fpx*MT_LH;
      var availH=Math.max(0.15, 2*Math.min(y,1-y)*0.96)*H;
      var k=Math.min(wMax>0?maxW/wMax:1, blockH>0?availH/blockH:1);
      if(k>=0.995)break;                       /* ca rentre : taille conservee */
      var ns=Math.max(minSize, s*k);
      if(ns>=s-0.01){ s=ns; break; }           /* plancher atteint */
      s=ns;
    }
    try{ _measCx.letterSpacing='0px'; }catch(_){}
    return {lines:lines, size:Math.round(s*100)/100};
  }
  /* conserve pour compatibilite : ne renvoie que la taille */
  function fitText(txt,x,y,fontId,weight,maxSize,minSize){
    var f=fontById(fontId);
    var fpxAtMax=sizeCqwFor(maxSize,state.shape)/100*MEASW;
    /* On évalue la largeur utile au BORD du texte (haut/bas du glyphe), là où
       l'hexagone est le plus étroit dans la bande occupée par le texte : ainsi rien
       ne sort jamais de la tomette, même si le cadre admin la dépasse. */
    var sh=SHAPES[state.shape]||SHAPES.carree, hPx=MEASW*(sh.hcm/sh.wcm);
    var halfH=(fpxAtMax*0.5)/hPx, yEdge=clamp(y+(y>=0.5?halfH:-halfH),0,1);
    var usable=usableW(x,yEdge,state.shape)*MEASW;
    _measCx.font=weight+' '+fpxAtMax+'px '+engraveCss(fontId,weight);
    var w=_measCx.measureText(txt).width||1;
    var size=maxSize*Math.min(1,usable/w);
    return Math.round(clamp(size,minSize,maxSize)*100)/100;
  }
  /* Normalise une mesure pour le visuel : ajoute toujours l'unité canonique (kg/cm),
     mais SANS doublon si le client a déjà tapé kg/kgs/kilo(s) ou cm/cms/centimètre(s)
     (maj/min, avec ou sans espace). Si pas de chiffre, on n'impose pas d'unité. */
  /* ===== valeurs de champs / variables / éléments actifs ===== */
  function fval(key){ var v=state.values[key]; return (v==null?'':String(v)); }
  function fmtDate(iso,fmt){ var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso||'')); if(!m)return String(iso||''); var y=m[1],mo=+m[2],d=+m[3]; var MN=['janvier','f\u00e9vrier','mars','avril','mai','juin','juillet','ao\u00fbt','septembre','octobre','novembre','d\u00e9cembre']; var dd=(d<10?'0':'')+d, mm=(mo<10?'0':'')+mo; if(fmt==='long0')return dd+' '+MN[mo-1]+' '+y; if(fmt==='dmy')return dd+'/'+mm+'/'+y; if(fmt==='dmy2')return dd+'/'+mm+'/'+y.slice(2); return d+' '+MN[mo-1]+' '+y; }
  function fmtFieldVal(raw,cfg){ var v=(raw==null?'':String(raw)); if(cfg){ if(cfg.input==='date'&&v)v=fmtDate(v,cfg.datefmt||'long'); var kase=cfg.kase||(cfg.upper?'upper':null); if(kase==='upper')v=v.toUpperCase(); else if(kase==='lower')v=v.toLowerCase(); } return v; }
  function varObj(nm,vars){ if(!vars)return null; for(var i=0;i<vars.length;i++){ if(vars[i].name===nm||vars[i].key===nm)return vars[i]; } return null; }
  function varKey(name,vars){ for(var i=0;i<(vars||[]).length;i++){ if(vars[i].name===name)return vars[i].key; } return null; }
  function applyTemplate(tpl,vars){
    var s=String(tpl||'');
    if(s.indexOf('[')>=0){
      s=s.replace(/\[([^\[\]]*)\]/g,function(m,seg){
        if(seg.indexOf('$')<0)return m;            /* pas de variable -> crochets littéraux conservés */
        var any=false, empty=false;
        seg.replace(/\$([^$\n]+)\$/g,function(mm,nm){ any=true; var k=varKey(nm.trim(),vars); if(!k||!String(fval(k)).trim())empty=true; return mm; });
        return (any&&empty)?'':seg;                /* une variable du segment est vide -> segment retiré */
      });
    }
    s=s.replace(/\$([^$\n]+)\$/g,function(m,nm){ var vo=varObj(nm.trim(),vars); return vo?fmtFieldVal(fval(vo.key),vo):''; });
    return s.replace(/ {2,}/g,' ').replace(/^[\s\u00b7\u2022|,;\u2013\u2014]+/,'').replace(/[\s\u00b7\u2022|,;\u2013\u2014]+$/,'');
  }
  function cDefWeight(font){ var fr=fontById(font); return (fr&&fr.grp==='manu')?400:600; }
  function isDropped(idx){ return !!state.dropped[idx]; }
  /* 03/09/2026 (ordinateur) : tant que le client n'a rien saisi ni retiré, la tomette garde sa recette d'exemple.
     Avant, choisir une forme ou le trou révélait un aperçu vidé de tous ses textes personnalisables. */
  function formPristine(){
    if(!(window.matchMedia&&matchMedia('(min-width:881px)').matches)) return false;
    try{ var k; for(k in state.values){ if(String(state.values[k]||'').trim()) return false; } for(k in state.dropped){ if(state.dropped[k]) return false; } }catch(e){ return false; }
    return true;
  }
  function exampleText(el){ return String(el.text||'').replace(/\[([^\[\]]*)\]/g,'$1').replace(/\$([^$\n]+)\$/g,function(_,n){ return n.trim(); }).replace(/\s+/g,' ').trim(); }
  function textValueOf(el){ var f=el.field; if(!f)return String(el.text||''); if(formPristine())return exampleText(el); if(f.kind==='template')return applyTemplate(el.text,f.vars); var v=fval(f.key); return (v&&v.trim())?fmtFieldVal(v,f):''; }  /* champ perso vide -> rien (masque tant que non saisi) */
  function tplHasInput(f){ try{ return (f.vars||[]).some(function(v){ return v&&v.key&&String(fval(v.key)).trim(); }); }catch(e){ return false; } }
  function textActive(el){ if(isDropped(el.__i))return false; var f=el.field; if(f&&formPristine()){ return !!exampleText(el); } if(f&&f.kind==='template'){ return tplHasInput(f) && !!applyTemplate(el.text,f.vars).trim(); } if(f){ return !!String(fval(f.key)).trim(); } return !!String(el.text||'').trim(); }
  /* logo lié à un champ : visible seulement si le champ référencé (clé) est rempli et non retiré */
  function linkSatisfied(el){
    if(!el.link)return true;
    var k=el.link, rels=RECIPE.elements||[];
    for(var i=0;i<rels.length;i++){ var e=rels[i]; if(e.type!=='text'||!e.field)continue; e.__i=i;
      if(e.field.kind==='template'){ if((e.field.vars||[]).some(function(v){return v.key===k;})&&textActive(e))return true; }
      else if(e.field.key===k&&textActive(e))return true;
    }
    return false;
  }
  function logoSize(el,key){ if(el.swap){for(var i=0;i<el.swap.length;i++){if(el.swap[i].logo===key&&el.swap[i].size!=null)return el.swap[i].size;}} return el.size; }
  function makeText(el,v,x,y){
    var font=el.font||'cormorant', weight=el.weight||cDefWeight(font), _k=shapeScale(state.shape);
    var maxS=el.size*_k, minS=Math.max(3,el.size*_k*0.5);
    /* le decoupage en lignes est calcule UNE fois et voyage avec l'element :
       l'apercu et le SVG laser consomment exactement le meme resultat. */
    var display=mtEffectText(el,v);
    /* Géométrie expert : taille dessinée conservée si elle rentre ; sinon réduction proportionnelle. */
    var L=mtHasCurve(el)?{lines:[display.replace(/\n/g,' ')],size:maxS}:mtLayoutText(display,x,y,font,weight,maxS,el.ls||0,state.shape,minS);
    if(mtHasCurve(el)||normRot(el.rot))L.size=mtFitEffectText(el,v,x,y,font,weight,L.size,state.shape);
    var o={type:'text',text:v,lines:L.lines,x:x,y:y,font:font,weight:weight,size:L.size,ls:el.ls||0};
    o.__i=el.__i; /* LABO Atelier mobile : l'index recette voyage avec l'element cuit */
    if(el.align&&el.align!=='center')o.align=el.align; return mtCopyEffects(el,o); }
  function logoPos(el,key){ if(el.swap){for(var i=0;i<el.swap.length;i++){if(el.swap[i].logo===key)return {x:el.swap[i].x,y:el.swap[i].y};}} return {x:null,y:null}; }
  function pushLogo(out,el,x,y){ var key=(state.swaps[el.__i])||el.logo; var p=logoPos(el,key); out.push(mtCopyEffects(el,{type:'icon',icon:key,x:(p.x!=null?p.x:x),y:(p.y!=null?p.y:y),size:logoSize(el,key)*shapeScale(state.shape),__i:el.__i})); }
  function avg(a){var s=0,n=0;for(var i=0;i<a.length;i++){if(a[i]!=null){s+=a[i];n++;}}return n?s/n:0.5;}
  /* GROUPE D'ALIGNEMENT (mise en page) = el.ag — distinct du bundle d'étape mobile (el.group, parcours seul).
     el.ag porte l'alignement (axe/répartition/zone). Repli : ancien format où el.group portait l'alignement. */
  function alignKey(el){ if(el.ag&&el.ag.id)return el.ag.id; var gg=el.group; if(gg&&gg.id&&(gg.axis||gg.distribute||gg.zone||gg.align||gg.gap!=null))return gg.id; return null; }
  function alignCfg(el){ return el.ag||el.group||{}; }

  /* ===== groupes : redistribution centrée à espacement fixe des items ACTIFS =====
     (généralise le recentrage de la rangée du bas du faire-part : 2 prénoms = aussi
      bien centrés et espacés que 4, mêmes interlignes) */
  function defaultGap(items,axis){ var ps=items.map(function(e){return axis==='horizontal'?e.x:e.y;}).sort(function(a,b){return a-b;}); if(ps.length<2)return 0.12; var d=0;for(var i=1;i<ps.length;i++)d+=ps[i]-ps[i-1]; return d/(ps.length-1); }
  function bakeGroup(out,items){
    var g=alignCfg(items[0]), axis=g.axis||'vertical', horiz=(axis==='horizontal');
    var isAct=function(el){ return el.type==='logo'?(!isDropped(el.__i)&&linkSatisfied(el)):textActive(el); };
    items.forEach(function(el){ if(el.solo===true && isAct(el)){ if(el.type==='logo')pushLogo(out,el,el.x,el.y); else out.push(makeText(el,String(textValueOf(el)).trim(),el.x,el.y)); } });
    var flowItems=items.filter(function(el){ return el.solo!==true; });
    var active=flowItems.filter(isAct);
    active.sort(function(a,b){ var ao=(a.field&&a.field.order!=null)?a.field.order:999, bo=(b.field&&b.field.order!=null)?b.field.order:999; return ao-bo; });
    if(!active.length)return;
    /* groupe SANS gap explicite (mise en page dessinée, ex. faire-part) et tous les membres remplis
       -> on respecte l'écartement dessiné. Les groupes À gap explicite (prénoms ajoutables : famille)
       redistribuent toujours, pour rester resserrés à 2 comme à 4. Sinon (membres absents) -> redistribution. */
    if(g.gap==null && (g.distribute||(g.zone?'even':'fixed'))==='fixed' && active.length===flowItems.length){
      active.forEach(function(el){ if(el.type==='logo')pushLogo(out,el,el.x,el.y); else out.push(makeText(el,String(textValueOf(el)).trim(),el.x,el.y)); });
      return;
    }
    var coordOf=function(e){return horiz?e.x:e.y;}, crossOf=function(e){return horiz?e.y:e.x;};
    /* crans : les membres partageant ag.row occupent un seul cran (et s'étalent côte à côte) */
    var slots=[], byRow={};
    active.forEach(function(el){ var r=(el.ag&&el.ag.row!=null&&el.ag.row!=='')?el.ag.row:null; if(r!=null&&byRow[r]){byRow[r].mem.push(el);} else {var s={mem:[el]}; if(r!=null)byRow[r]=s; slots.push(s);} });
    slots.forEach(function(s){ s.coord=avg(s.mem.map(coordOf)); });
    var n=slots.length, lo,hi,cross;
    if(g.zone){ lo=(horiz?g.zone.x:g.zone.y); hi=lo+(horiz?g.zone.w:g.zone.h); cross=(horiz?(g.zone.y+g.zone.h/2):(g.zone.x+g.zone.w/2)); }
    else { var cs=slots.map(function(s){return s.coord;}); lo=Math.min.apply(null,cs); hi=Math.max.apply(null,cs); cross=(horiz?(g.cy!=null?g.cy:avg(flowItems.map(function(e){return e.y;}))):(g.cx!=null?g.cx:avg(flowItems.map(function(e){return e.x;})))); }
    var distribute=g.distribute||(g.zone?'even':'fixed'), positions=[];
    if(distribute==='even'){
      if(g.zone){ for(var kz=0;kz<n;kz++)positions.push(lo+(kz+0.5)*(hi-lo)/n); }
      else if(n===1)positions=[(lo+hi)/2]; else for(var k=0;k<n;k++)positions.push(lo+k*(hi-lo)/(n-1));
    } else {
      var gap=(g.gap!=null?g.gap:defaultGap(flowItems,axis)), span=gap*(n-1), anchor=g.align||'center', start;
      if(g.zone){ start=(anchor==='start'?lo:(anchor==='end'?(hi-span):((lo+hi)/2-span/2))); }
      else { var c=(horiz?(g.cx!=null?g.cx:avg(flowItems.map(coordOf))):(g.cy!=null?g.cy:avg(flowItems.map(coordOf)))); start=c-span/2; }
      for(var k2=0;k2<n;k2++)positions.push(start+k2*gap);
    }
    function place(el,mainPos,crossPos){ var x=(horiz?mainPos:crossPos), y=(horiz?crossPos:mainPos); if(el.type==='logo')pushLogo(out,el,x,y); else out.push(makeText(el,String(textValueOf(el)).trim(),x,y)); }
    slots.forEach(function(s,k){
      var pos=positions[k];
      if(s.mem.length===1){ place(s.mem[0],pos,cross); }
      else { var rc=avg(s.mem.map(crossOf)), off=cross-rc; s.mem.forEach(function(el){ place(el,pos,crossOf(el)+off); }); }
    });
  }
  function bakeEls(){
    var out=[], rels=RECIPE.elements||[], groups={}, order=[];
    rels.forEach(function(el,idx){ el.__i=idx; var gid=alignKey(el); if(gid){ (groups[gid]||(groups[gid]=[])).push(el); if(order.indexOf(gid)<0)order.push(gid); } });
    rels.forEach(function(el){
      if(alignKey(el))return;
      if(el.type==='logo'){ if(!isDropped(el.__i)&&linkSatisfied(el))pushLogo(out,el,el.x,el.y); }
      else if(textActive(el)) out.push(makeText(el,String(textValueOf(el)).trim(),el.x,el.y));
    });
    order.forEach(function(gid){ bakeGroup(out,groups[gid]); });
    state.els=out;
  }
  /* ===== Texte pour l'EXPERT : on part du MODÈLE D'ORIGINE et on remplit chaque variable par la
     valeur saisie si elle existe, sinon par la valeur d'exemple (nom de la variable / texte du
     modèle). Ainsi l'expert n'affiche JAMAIS de blanc, contrairement aux champs vides du guidé. */
  function applyTemplateSmart(tpl,vars){
    var s=String(tpl||'').replace(/\[([^\[\]]*)\]/g,function(m,seg){ return seg; }); /* segments optionnels : on garde le contenu */
    s=s.replace(/\$([^$\n]+)\$/g,function(m,nm){
      var vo=varObj(nm.trim(),vars);
      if(vo){ var v=fval(vo.key); return (v&&String(v).trim())?fmtFieldVal(v,vo):(vo.name||nm.trim()); }
      return nm.trim();
    });
    return s.replace(/ {2,}/g,' ').trim();
  }
  function expertTextOf(el){
    var f=el.field;
    if(f&&f.kind==='template')return applyTemplateSmart(el.text,f.vars);
    if(f){ var v=fval(f.key); return (v&&String(v).trim())?fmtFieldVal(v,f):String(el.text||''); }
    return String(el.text||'');
  }
  function getRecipe(forExpert){
    var sh=SHAPES[state.shape]||SHAPES.carree;
    var out={v:2,mode:MODE,shape:state.shape,hole:!!state.hole,dims:{w_mm:sh.wcm*10,h_mm:sh.hcm*10},
      prices:(function(){var m={};for(var k in VARIANTS){if(VARIANTS[k]&&VARIANTS[k].price!=null)m[k]=VARIANTS[k].price;}return m;})()};
    if(forExpert){
      /* Éléments de la RECETTE D'ORIGINE (le modèle), avec valeurs saisies-ou-exemple.
         Logos : même logique que le mode normal (SVG embarqué seulement si logo admin/template). */
      out.elements=(RECIPE.elements||[]).map(function(el){
        if(el.type==='text'){
          var t={type:'text',text:expertTextOf(el),x:el.x,y:el.y,font:el.font,size:el.size,weight:el.weight,ls:el.ls||0,color:'#4a2616'};
          if(el.align)t.align=el.align; return mtCopyEffects(el,t);
        }
        var o={type:'logo',logo:el.logo,x:el.x,y:el.y,size:el.size,color:'#4a2616'};
        var l=LOGOCAT[el.logo];
        if(l&&l.clientVisible===false&&l.svg)o.svg=sanitizeSvg(l.svg);
        else if(!l)o.svg=sanitizeSvg(el.svg||HEART_FALLBACK);
        return mtCopyEffects(el,o);
      }).filter(function(e){ return e.type!=='text' || (e.text&&e.text.trim()); });
      return out;
    }
    out.elements=state.els.map(function(e){
      if(e.type==='text'){ var t={type:'text',text:e.text,x:e.x,y:e.y,font:e.font,size:e.size,weight:e.weight,ls:e.ls||0,color:'#4a2616'}; if(e.align)t.align=e.align; return mtCopyEffects(e,t); }
      var o={type:'logo',logo:e.icon,x:e.x,y:e.y,size:e.size,color:'#4a2616'};
      var l=LOGOCAT[e.icon];
      if(l&&l.clientVisible===false&&l.svg)o.svg=sanitizeSvg(l.svg);
      else if(!l)o.svg=sanitizeSvg(HEART_FALLBACK);
      return mtCopyEffects(e,o);
    });
    return out;
  }
  function seedRecipeLogos(){ (RECIPE.elements||[]).forEach(function(el){ if(el.type!=='logo')return; if(el.svg&&!LOGOCAT[el.logo])LOGOCAT[el.logo]={svg:el.svg,name:el.logo,clientVisible:false}; (el.swap||[]).forEach(function(o){ if(o.svg&&!LOGOCAT[o.logo])LOGOCAT[o.logo]={svg:o.svg,name:o.logo,clientVisible:false}; }); }); _svgClean=Object.create(null); }
  function modelLink(){return CONFIG_BASE+'#d='+_b64enc(JSON.stringify(getRecipe()));}
  function _b64enc(str){ try{ return btoa(unescape(encodeURIComponent(String(str)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); }catch(e){ return ''; } }
  function _b64dec(b){ try{ var t=String(b||'').replace(/-/g,'+').replace(/_/g,'/'); while(t.length%4)t+='='; return decodeURIComponent(escape(atob(t))); }catch(e){ return ''; } }
  /* Lien d'edition : renvoie vers CETTE page produit avec les valeurs de champ dans le hash (#g=) -> preremplissage guide. */
  function editLink(){ return location.pathname + '#g=' + _b64enc(JSON.stringify({vals:state.values,shape:state.shape,hole:!!state.hole,dropped:state.dropped})); }

  /* ============================ DONNÉES ============================ */
  function logoPublicFileUrl(path){
    path=String(path||'').trim();
    if(!path)return '';
    if(/^https?:\/\//i.test(path))return path;
    try{
      var endpoint=new URL(URL_LOGOS,location.href);
      endpoint.search='?resource=asset&path='+encodeURIComponent(path.replace(/^\/+/,''));
      return endpoint.href;
    }catch(e){return path;}
  }
  /* ---- Vignettes du selecteur : previews WebP du catalogue ----------------
     Le manifeste expose pour chaque logo un chemin `preview` (WebP 256 px,
     ~1,5 Ko). On affiche ces images au lieu d'injecter le SVG complet dans
     chaque bouton : sur une fiche a 34 options, l'injection inline coutait
     ~163 ms de parsing + ~98 ms de mise en page et 683 noeuds DOM.
     Repli automatique sur le SVG inline pour tout logo absent du manifeste
     (creations IA, sur-mesure) : aucun bouton ne peut rester vide. */
  /* Les previews sont servies en statique par l'hebergeur (verifie : le chemin
     direct renvoie l'image, une cle inexistante renvoie 404). On evite donc une
     execution PHP par vignette. La base est deduite de URL_LOGOS : aucun domaine
     en dur, si l'admin demenage le chemin suit. */
  function logoStaticUrl(path){
    path=String(path||'').trim(); if(!path)return '';
    if(/^https?:\/\//i.test(path))return path;
    try{ return new URL(path.replace(/^\/+/,''), URL_LOGOS).href; }catch(e){ return logoPublicFileUrl(path); }
  }
  var LOGOPREV=Object.create(null), LOGOSRC=Object.create(null), _prevState=0, _prevWait=null;
  /* Recupere le SVG d'un logo a la demande (au clic ou au survol). Les dessins
     optionnels n'ont plus besoin de voyager dans la recette : le catalogue les
     sert en fichiers a hash de contenu, donc immuables et caches pour toujours,
     partages entre toutes les fiches produit. */
  var _svgWait=Object.create(null);
  function ensureLogoSvg(k){
    if(!k)return Promise.resolve(false);
    if(LOGOCAT[k]&&LOGOCAT[k].svg)return Promise.resolve(true);
    if(_svgWait[k])return _svgWait[k];
    _svgWait[k]=loadPreviews().then(function(){
      var u=LOGOSRC[k];
      if(!u)return false;
      return fetch(u,{cache:'force-cache',priority:'low'})
        .then(function(r){return r.ok?r.text():'';})
        .then(function(raw){
          var svg=sanitizeSvg(raw); if(!svg)return false;
          var p=LOGOCAT[k]||{};
          LOGOCAT[k]={name:p.name||k,category:p.category||'',minSize:p.minSize,maxSize:p.maxSize,svg:svg};
          delete _svgClean[k]; delete _logoSlots[k];
          scheduleLive(); try{refreshLogoThumbs();}catch(e){}
          return true;
        });
    }).catch(function(){ return false; });
    return _svgWait[k];
  }
  function loadPreviews(){
    if(_prevState===2)return Promise.resolve();
    if(_prevWait)return _prevWait;
    _prevState=1;
    _prevWait=fetch(URL_LOGOS,{cache:'no-cache',priority:'low'})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(d){ if(d&&d.logos){ for(var k in d.logos){ var rec=d.logos[k];
        if(rec&&rec.preview)LOGOPREV[k]=logoStaticUrl(rec.preview);
        /* Les previews passent en <img> : le chemin statique suffit, pas de CORS.
           Le SVG est recupere en fetch() : le statique est refuse faute d'en-tete
           Access-Control-Allow-Origin (verifie dans le navigateur), on garde donc
           la route PHP qui, elle, l'envoie. */
        if(rec&&rec.svg)LOGOSRC[k]=logoPublicFileUrl(rec.svg); } } })
      .catch(function(){})
      .then(function(){ _prevState=2; });
    return _prevWait;
  }
  function missingRecipeLogoKeys(){
    var out=[],seen={};
    function add(k){if(k&&!seen[k]&&!(LOGOCAT[k]&&LOGOCAT[k].svg)){seen[k]=1;out.push(k);}}
    (RECIPE.elements||[]).forEach(function(el){
      if(el.type!=='logo')return;
      add(el.logo);
      /* les dessins optionnels ne sont plus reclames au chargement :
         ensureLogoSvg() va les chercher au survol ou au clic. */
    });
    return out;
  }
  function loadLogos(){
    var needed=missingRecipeLogoKeys();
    if(!needed.length)return; /* cas normal : les SVG utiles sont déjà dans la recette */
    function finish(){seedRecipeLogos();_logoSlots={};scheduleLive();try{refreshLogoThumbs();}catch(e){}}
    function applyLegacy(d){
      if(!d||!d.logos)return;
      needed.forEach(function(k){if(d.logos[k])LOGOCAT[k]=d.logos[k];});
    }
    try{
      fetch(URL_LOGOS,{cache:'no-cache',priority:'low'}).then(function(r){return r.ok?r.json():null;}).then(function(d){
        if(!d||!d.logos)throw new Error('manifest unavailable');
        return Promise.all(needed.map(function(k){
          var rec=d.logos[k];
          if(!rec||!rec.svg)return false;
          return fetch(logoPublicFileUrl(rec.svg),{cache:'force-cache',priority:'low'}).then(function(r){return r.ok?r.text():'';}).then(function(raw){
            var svg=sanitizeSvg(raw);if(!svg)return false;
            LOGOCAT[k]={name:rec.name||k,category:rec.category||'',minSize:rec.minSize,maxSize:rec.maxSize,svg:svg};
            return true;
          }).catch(function(){return false;});
        }));
      }).then(function(){
        var still=missingRecipeLogoKeys();
        if(!still.length)return;
        needed=still;
        return fetch(URL_LOGOS_FALLBACK,{cache:'no-cache',priority:'low'}).then(function(r){return r.ok?r.json():null;}).then(applyLegacy);
      }).then(finish).catch(function(){
        fetch(URL_LOGOS_FALLBACK,{cache:'no-cache',priority:'low'}).then(function(r){return r.ok?r.json():null;}).then(applyLegacy).then(finish).catch(finish);
      });
    }catch(e){finish();}
  }
  function loadFontsCdn(){
    var missing={};
    (RECIPE.elements||[]).forEach(function(el){if(el&&el.type==='text'&&el.font&&!FONTREG[el.font])missing[el.font]=1;});
    if(!Object.keys(missing).length){fontsSettled();return;} /* la recette contient déjà ses seules polices utiles */
    fetch(URL_FONTS,{cache:'no-cache'}).then(function(r){return r.ok?r.json():null;}).then(function(d){
      if(d&&d.fonts){buildFonts(d.fonts);mergeFonts(RECIPE.fonts||[]);injectFaces(d.fonts);}
      fontsSettled();
    }).catch(function(){fontsSettled();});
  }
  function mtpLoadWebFont(fam,w){
    w=parseInt(w,10)||400;
    var key=fam+'|'+w;
    if(_mtpWebFontLoads[key])return _mtpWebFontLoads[key];
    if(!fam||!/^[A-Za-z0-9][A-Za-z0-9 ]*$/.test(fam)||!document.fonts||!document.fonts.load)return Promise.resolve(false);
    var direct=false;
    for(var id in FONTREG){
      var fr=FONTREG[id], u=fr&&(fr.url||fr.ttf);
      if(fr&&(fr.family||id)===fam&&u&&/\.(ttf|otf|woff2?|eot)(\?|$)/i.test(u))direct=true;
    }
    var cssReady=direct?Promise.resolve(true):new Promise(function(resolve){
      var lid='mtpgf-'+fam.toLowerCase().replace(/[^a-z0-9]+/g,'-')+'-'+w;
      var l=document.getElementById(lid);
      if(l&&l.sheet){resolve(true);return;}
      var fresh=!l;
      if(!l){l=document.createElement('link');l.id=lid;l.rel='stylesheet';}
      l.addEventListener('load',function(){resolve(true);},{once:true});
      l.addEventListener('error',function(){resolve(false);},{once:true});
      if(fresh){
        l.href='https://fonts.googleapis.com/css2?family='+fam.replace(/\s+/g,'+')+':wght@'+w+'&display=swap';
        document.head.appendChild(l);
      }
    });
    _mtpWebFontLoads[key]=cssReady.then(function(ok){
      if(!ok)return false;
      return document.fonts.load(w+" 24px '"+fam+"'").then(function(){mtpQueueFontRender();return true;},function(){return false;});
    }).catch(function(){return false;});
    return _mtpWebFontLoads[key];
  }
  function fontsSettled(){
    var seen={};
    (RECIPE.elements||[]).forEach(function(el){
      if(!el||el.type!=='text')return;
      var fid=el.font||'cormorant', w=el.weight||cDefWeight(fid), fam=famOf(fid), key=fam+'|'+w;
      if(seen[key])return;
      seen[key]=true;
      var alias=engraveFamFor(fid,w), pending=alias&&_mteFontLoads[alias];
      if(pending){pending.then(function(ok){if(!ok)mtpLoadWebFont(fam,w);});}
      else if(!alias){mtpLoadWebFont(fam,w);}
    });
  }
  function reRender(){ rebake(); }

  /* ============================ RENDU + PRIX + CTA ============================ */
  function syncEmpty(){ var any=false,vs=state.values; for(var k in vs){ if(String(vs[k]||'').trim()){any=true;break;} } $('mtpEmpty').classList.toggle('mtp-hide', any); }
  function rebake(){ mtePrepFonts(state.els); $('mtpTile').classList.toggle('mtp-sq', (SHAPES[state.shape]||SHAPES.carree).cls==='sq'); syncEmpty(); bakeEls(); applyHole(); scheduleLive(); updatePriceUI(); updateCTA(); }
  function curVar(){
    var ho=(state.hole?1:0), k=state.shape+'|'+ho, kk;
    if(VARIANTS[k])return VARIANTS[k];
    for(kk in VARIANTS){ if(kk.split('|')[1]===String(ho))return VARIANTS[kk]; } /* repli : meme trou, forme non encodee par la variante */
    for(kk in VARIANTS){ return VARIANTS[kk]; }                                  /* dernier repli : 1re variante dispo */
    return null;
  }
  function basePrice(){ var v=curVar(); return v?v.price:0; }
  function variantId(){ var v=curVar(); return v?v.id:''; }
  function updatePriceUI(){ /* le prix est porté par le CTA ; rien à mettre à jour ici */ }
  function collectFields(){
    var list=[];
    (RECIPE.elements||[]).forEach(function(el,idx){ var f=el.field; if(!f)return;
      var grp=el.group&&el.group.id, del=el.group&&el.group.deletable, gtit=(el.group&&el.group.title)||'';
      if(f.kind==='template'){ (f.vars||[]).forEach(function(v){ list.push({key:v.key,label:v.label||v.name,example:v.example||'',placeholder:v.placeholder||'',required:!!v.required,kase:(v.kase||(v.upper?'upper':'')),input:(v.input||''),datefmt:(v.datefmt||'long'),order:f.order,el:idx,group:grp,gtitle:gtit,tlabel:(f.label||''),deletable:del}); }); }
      else { var _bt=String(el.text||'').replace(/\$[^$\n]+\$/g,'').replace(/[\[\]]/g,'').trim(); var _lbl=f.label||_bt;
        if(!_lbl && !f.example && !f.placeholder && !f.required) return; /* texte guidé vide -> pas de champ fantôme */
        list.push({key:f.key,label:_lbl||'Texte',example:f.example||'',placeholder:f.placeholder||'',required:!!f.required,kase:(f.kase||(f.upper?'upper':'')),input:(f.input||''),datefmt:(f.datefmt||'long'),order:f.order,el:idx,group:grp,gtitle:gtit,tlabel:(f.label||_bt||''),deletable:del}); }
    });
    list.sort(function(a,b){ var ao=(a.order==null?999:a.order),bo=(b.order==null?999:b.order); return ao-bo; });
    return list;
  }
  /* ===== logos personnalisables (mode guidé) : le client choisit parmi une sélection définie par l'admin ===== */
  var LOGOFIELDS=[];
  function collectLogoFields(){
    var list=[];
    (RECIPE.elements||[]).forEach(function(el,idx){
      if(el.type!=='logo')return;
      var sw=el.swap; if(!sw||sw.length<2)return;   /* au moins une alternative, sinon rien à choisir */
      var f=el.field||{};
      list.push({el:idx, key:el.logo, options:sw, label:(f.label||''), order:(f.order!=null?f.order:null)});
    });
    return list;
  }
  function logoName(k){ var l=LOGOCAT[k]; return (l&&l.name)||k; }
  function logoChooserHTML(st){
    var lf=st.logo, cur=state.swaps[lf.el]||lf.key, h='<div class="mtp-logos">';
    lf.options.forEach(function(o){ var k=o.logo, sel=(k===cur);
      h+='<button type="button" class="mtp-logobtn'+(sel?' mtp-on':'')+'" data-swapel="'+lf.el+'" data-swapkey="'+esc(k)+'" aria-pressed="'+(sel?'true':'false')+'" title="'+esc(logoName(k))+'"><span class="mtp-logosvg"></span></button>';
    });
    return h+'</div>';
  }
  /* Remplit les boutons du selecteur : preview WebP si le catalogue en fournit
     une, sinon SVG inline. Rejoue apres loadLogos() : __mtRaw memorise ce qui
     est en place pour ne reinjecter que ce qui a reellement change. */
  function refreshLogoThumbs(){ try{ Array.prototype.forEach.call(document.querySelectorAll('.mtp-logobtn[data-swapkey]'),function(b){
    var k=b.getAttribute('data-swapkey'), s=b.querySelector('.mtp-logosvg'); if(!s)return;
    var u=LOGOPREV[k];
    if(u){ if(s.getAttribute('data-prev')!==u){ s.setAttribute('data-prev',u); s.__mtRaw=null; s.innerHTML='';
      var im=document.createElement('img');
      im.alt='';im.width=256;im.height=256;im.loading='lazy';im.decoding='async';
      /* preview injoignable : on l'oublie pour cette cle et on retombe sur le SVG */
      im.onerror=function(){ delete LOGOPREV[k]; s.removeAttribute('data-prev');
        var r2=logoSvgRaw(k); s.__mtRaw=r2; s.innerHTML=r2; };
      im.src=u; s.appendChild(im); } return; }
    if(_prevState!==2)return;              /* manifeste pas encore arrive : on patiente */
    var raw=logoSvgRaw(k);
    if(s.__mtRaw!==raw){ s.__mtRaw=raw; s.removeAttribute('data-prev'); s.innerHTML=raw; }
  }); }catch(e){} }
  function missingRequired(){ return FIELDS.filter(function(f){ return f.required && !isDropped(f.el) && !fval(f.key).trim(); }); }
  function inputForKey(key){ var r=null; try{ Array.prototype.forEach.call(document.querySelectorAll('#mtp input.mtp-fin[data-fk]'),function(i){ if(!r && i.getAttribute('data-fk')===key) r=i; }); }catch(e){} return r; }
  function clearFieldErrors(){ try{ Array.prototype.forEach.call(document.querySelectorAll('#mtp .mtp-fin-err'),function(i){ i.classList.remove('mtp-fin-err'); }); }catch(e){} }
  function focusMissing(f){ var inp=inputForKey(f.key); var step=(inp&&inp.closest)?inp.closest('.mtp-step'):null; if(step){ try{ window.dispatchEvent(new CustomEvent('mtp:gotostep',{detail:{step:step,key:f.key}})); }catch(e){} try{ var body=step.querySelector('.mtp-stepbody'); if(body&&getComputedStyle(body).maxHeight==='0px'){ var head=step.querySelector('.mtp-stephead'); if(head)head.click(); } }catch(e){} } if(inp){ setTimeout(function(){ try{ inp.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){} try{ inp.focus({preventScroll:true}); }catch(e2){ try{inp.focus();}catch(e3){} } },90); } }
  function validateRequired(){ var miss=missingRequired(); if(!miss.length)return true; clearFieldErrors(); miss.forEach(function(f){ var i=inputForKey(f.key); if(i)i.classList.add('mtp-fin-err'); }); var lbl=window.MT_CONFIG_I18N.label((miss[0].label||'').trim()); toast(miss.length>1?(window.MT_CONFIG_I18N.text("ui_9c9e9cc0e5ac_html", "Complétez les ")+miss.length+window.MT_CONFIG_I18N.text("ui_ea9eebaea387_html", " champs obligatoires avant d'ajouter au panier")):(window.MT_CONFIG_I18N.text("ui_baf3a65dc493_html", "Complétez le champ « ")+(lbl||window.MT_CONFIG_I18N.text("ui_d2152c29b58a_html", "obligatoire"))+window.MT_CONFIG_I18N.text("ui_192830475998_html", " » avant d'ajouter au panier"))); focusMissing(miss[0]); return false; }
  function displayEuro(amount){
    if(/^en(?:-|$)/i.test(window.MT_CONFIG_I18N.locale || '')){
      try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:'EUR',minimumFractionDigits:2,maximumFractionDigits:2}).format(amount);}catch(_){}
      return '€'+Number(amount).toFixed(2);
    }
    return amount+' €';
  }
  function updateCTA(){
    /* plus de protection sur les champs requis : la recette d'origine est un visuel valable par defaut */
    var btn=$('mtpAdd'); btn.disabled=false;
    btn.textContent=(EDIT_KEY?window.MT_CONFIG_I18N.text("ui_0995bd97449d_html", "Modifier ma tomette — "):window.MT_CONFIG_I18N.text("ui_ca56e7818f7a_html", "Ajouter au panier — "))+displayEuro(basePrice()*qty);
  }
  /* ============================ PANIER ============================ */
  var SHOP_LIVE=false;
  try{fetch(window.MT_CONFIG_I18N.url("/cart.js"),{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(c){if(c&&typeof c.item_count!=='undefined')SHOP_LIVE=true;})['catch'](function(){});}catch(e){}
  function isLive(){return SHOP_LIVE || /myshopify\.com|shopifypreview\.com|mytomette/i.test(location.hostname);}
  function dataUrlToBlob(u){try{var b=atob(u.split(',')[1]),a=new Uint8Array(b.length);for(var i=0;i<b.length;i++)a[i]=b.charCodeAt(i);return new Blob([a],{type:'image/png'});}catch(e){return null;}}
  function navTop(url){window.location.assign(url);}
  function addToCart(){
    if(addToCart._busy)return;
    if(!validateRequired())return;
    var vid=variantId();
    if(!vid){toast(window.MT_CONFIG_I18N.text("ui_8f18596af782_html", "Variante indisponible pour cette forme"));return;}
    if(!isLive()){toast(window.MT_CONFIG_I18N.text("ui_3955af2b57a0_html", "Aperçu — l'ajout au panier fonctionne sur la boutique en ligne"));return;}
    addToCart._busy=true; showLoading();
    setLoad(8,window.MT_CONFIG_I18N.text("ui_4f6b213f5805_html", "Préparation de votre tomette…"),window.MT_CONFIG_I18N.text("ui_c2d4f18bde72_html", "on prépare votre fichier")); startCreep(8,24,2000);
    var ac=(window.AbortController?new AbortController():null), stopped=false;
    clearTimeout(addToCart._re); clearTimeout(addToCart._cap);
    /* On ne coupe PLUS le process quand c'est simplement lent (mobile sans cache) : on rassure sans annuler. */
    addToCart._re=setTimeout(function(){ if(addToCart._busy){ setLoad(null,window.MT_CONFIG_I18N.text("ui_721b5933a47b_html", "Presque prêt…"),window.MT_CONFIG_I18N.text("ui_9d9bcd98c4f7_html", "connexion un peu lente — on continue, ne fermez pas")); } },12000);
    /* Filet de sécurité TRÈS large : on n'abandonne (et on annule, pour éviter un doublon fantôme) qu'en cas de vrai blocage réseau. */
    addToCart._cap=setTimeout(function(){ if(!addToCart._busy)return; stopped=true; try{if(ac)ac.abort();}catch(e){} clearTimeout(addToCart._re); stopCreep(); addToCart._busy=false; hideLoading(); toast(window.MT_CONFIG_I18N.text("ui_5a47c31ffb8e_html", "La connexion semble bloquée — vérifiez votre réseau et réessayez")); },60000);
    var sh=SHAPES[state.shape]||SHAPES.carree, forme=sh.label+(state.hole?' (percée)':'');
    var requireEffectSVG=mtRequiresEffectSVG(state),svgReady=false,pngSettled=false;
    var exportSource=requireEffectSVG?{shape:state.shape,hole:!!state.hole,els:JSON.parse(JSON.stringify(state.els))}:state;
    var fd=new FormData(); fd.append('id',vid); fd.append('quantity',String(qty||1));
    var textProps={};
    /* 05/10/2026 : deux champs de meme etiquette (« Brindille couple » : Prénom & Prénom) donnaient deux
       proprietes de meme nom, et Shopify ne gardait que la derniere : « benjamin » disparaissait de la
       relecture du panier et de la commande. Le 2e devient « Prénom 2 », le 3e « Prénom 3 »... */
    var _labVus={};
    FIELDS.forEach(function(f){ if(isDropped(f.el))return; var v=fmtFieldVal(fval(f.key),f).trim(); if(v){ var lab=String(f.label||'Texte'), nb=(_labVus[lab]=(_labVus[lab]||0)+1); if(nb>1)lab=lab+' '+nb; fd.append('properties['+lab+']',v); textProps[lab]=v; } });
    fd.append('properties[Forme]',forme); textProps['Forme']=forme;
    if(state.hole){ fd.append('properties[Trou de suspension]','Oui'); textProps['Trou de suspension']='Oui'; }
    fd.append('properties[_source]','guided'); textProps['_source']='guided';
    try{ var editUrl=editLink(); fd.append('properties[_modifier]',editUrl); textProps['_modifier']=editUrl; }catch(e){}
    try{ fd.append('properties[_Recette]', new Blob([JSON.stringify(getRecipe())],{type:'application/json'}), 'recette.json'); }catch(e){}
    /* Les nouveaux effets nécessitent leur fichier de gravure. Le PNG reste
       facultatif et se prépare en parallèle. Sans effet, repli historique. */
    var posted=false;
    function failEffectSVG(){
      if(posted||stopped)return;stopped=true;
      clearTimeout(safety);clearTimeout(addToCart._re);clearTimeout(addToCart._cap);
      try{if(ac)ac.abort();}catch(_){}stopCreep();addToCart._busy=false;hideLoading();
      toast(window.MT_CONFIG_I18N.text("ui_57483a31d465_html", "La gravure n’a pas pu être préparée. Réessayez dans un instant."));
    }
    function go(){
      if(posted||stopped)return;
      if(requireEffectSVG&&!svgReady){failEffectSVG();return;}
      posted=true;setLoad(84,window.MT_CONFIG_I18N.text("ui_847fc20d1043_html", "Ajout au panier…"),window.MT_CONFIG_I18N.text("ui_2e4bd22123d2_html", "presque terminé"));startCreep(84,96,20000);
      postCartAdd(fd,textProps,vid,ac,function(){return stopped;},requireEffectSVG);
    }
    var safety=setTimeout(function(){if(requireEffectSVG&&!svgReady)failEffectSVG();else go();},9000);
    function attachPNG(pngUrl){
      if(stopped||posted||pngSettled)return;
      try{var pb=pngUrl&&dataUrlToBlob(pngUrl);if(pb)fd.append('properties[_Aperçu]',pb,'apercu.png');}catch(_){}
      pngSettled=true;if(requireEffectSVG&&svgReady){clearTimeout(safety);go();}
    }
    function finishSVG(svg){
      if(stopped||posted||svgReady)return;
      try{if(svg){fd.append('properties[_Gravure SVG]',new Blob([svg],{type:'image/svg+xml'}),'gravure-laser.svg');svgReady=true;}}catch(_){}
      if(requireEffectSVG&&!svgReady){failEffectSVG();return;}
      if(!requireEffectSVG||pngSettled){clearTimeout(safety);go();}
    }
    try{
      setLoad(40,window.MT_CONFIG_I18N.text("ui_c75e2f0e1966_html", "Création de l'aperçu…"),window.MT_CONFIG_I18N.text("ui_095ceb44698d_html", "rendu de votre tomette"));
      if(requireEffectSVG){
        try{renderPNG(exportSource,attachPNG);}catch(_){attachPNG(null);}
        setLoad(66,window.MT_CONFIG_I18N.text("ui_dd24e1dd763e_html", "Génération de la gravure…"),window.MT_CONFIG_I18N.text("ui_911b7b26a3e1_html", "fichier laser haute précision"));
        buildLaserSVG(exportSource,finishSVG);
      }else{
        renderPNG(state,function(pngUrl){
          if(stopped||posted)return;attachPNG(pngUrl);
          setLoad(66,window.MT_CONFIG_I18N.text("ui_dd24e1dd763e_html", "Génération de la gravure…"),window.MT_CONFIG_I18N.text("ui_911b7b26a3e1_html", "fichier laser haute précision"));
          buildLaserSVG(state,finishSVG);
        });
      }
    }catch(e){clearTimeout(safety);go();}
  }

  function postCartAdd(fd,textProps,vid,ac,isStopped,requireEffectSVG){
    var sig=(ac?ac.signal:undefined);
    function stopped(){ return !!(isStopped&&isStopped()); }
    function clearAll(){ clearTimeout(addToCart._re); clearTimeout(addToCart._cap); stopCreep(); }
    function done(){ function fin(){clearAll();addToCart._busy=false;hideLoading();notifyCart();toast(EDIT_KEY?window.MT_CONFIG_I18N.text("ui_cda9e7aaac9c_html", "Tomette mise à jour ✓"):window.MT_CONFIG_I18N.text("ui_6d08e54801ad_html", "Ajouté au panier ✓"));navTop(window.MT_CONFIG_I18N.url("/cart"));} if(EDIT_KEY){ fetch(window.MT_CONFIG_I18N.url("/cart/change.js"),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:EDIT_KEY,quantity:0}),signal:sig}).then(fin,fin); } else { fin(); } }
    function fail(err){ if(stopped()||(err&&err.name==='AbortError'))return; clearAll();addToCart._busy=false;hideLoading();toast(window.MT_CONFIG_I18N.text("ui_f51825eb9f15_html", "Panier : ")+((err&&err.message)?err.message:window.MT_CONFIG_I18N.text("ui_7d2988c9e76f_html", "erreur")));}
    function chk(r){ if(!r.ok){ return r.json().then(function(j){throw new Error((j&&(j.description||j.message))||('HTTP '+r.status));},function(){throw new Error('HTTP '+r.status);}); } return r.json(); }
    fetch(window.MT_CONFIG_I18N.url("/cart/add.js"),{method:'POST',body:fd,signal:sig}).then(chk).then(done)
      ['catch'](function(err){
        if(stopped()||(err&&err.name==='AbortError'))return;
        if(requireEffectSVG){fail(err);return;} /* pas de repli JSON qui perdrait le SVG obligatoire */
        fetch(window.MT_CONFIG_I18N.url("/cart/add.js"),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:(qty||1),properties:textProps}]}),signal:sig})
          .then(chk).then(done)['catch'](fail);
      });
  }
  function notifyCart(){setTimeout(function(){try{fetch(window.MT_CONFIG_I18N.url("/cart.js"),{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(cart){var n=(cart&&typeof cart.item_count!=='undefined')?cart.item_count:undefined;try{document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{data:{itemCount:n,source:'mytomette-fairepart'},cart:cart}}));}catch(e){}try{document.dispatchEvent(new CustomEvent('cart:build'));}catch(e){}})['catch'](function(){});}catch(e){}},280);}

  /* ============================ ÉVÉNEMENTS ============================ */
  var hero=$('mtpHero'), formEl=$('mtpForm');
  var FIELDS=[];   /* rempli à l'init par collectFields() */

  function CSS_esc(x){ return String(x).replace(/["\\\]]/g,'\\$&'); }
  function baseLabel(lab){ return String(lab||'').replace(/\s*\d+\s*$/,'').trim(); }
  function placeholderFor(f){
    if(f.placeholder) return window.MT_CONFIG_I18N.placeholder(f.placeholder);
    var b=window.MT_CONFIG_I18N.label(baseLabel(f.label))||window.MT_CONFIG_I18N.text("ui_d86675fccb07_html", "votre texte");
    var p=window.MT_CONFIG_I18N.text("ui_d6901d27faf9_html", "Tapez ")+b.toLowerCase();
    if(f.example) p+=window.MT_CONFIG_I18N.text("ui_d8bb274b2871_html", "… ex. ")+f.example;
    return p;
  }
  function groupTitle(arr){
    if(arr[0].gtitle) return window.MT_CONFIG_I18N.label(arr[0].gtitle);
    var b=baseLabel(arr[0].label)||window.MT_CONFIG_I18N.text("ui_412be0b9cd40_html", "Informations");
    return /^(?:en|es)/.test(window.MT_CONFIG_I18N.locale) ? window.MT_CONFIG_I18N.label(b) : 'Les '+b.toLowerCase()+'s';
  }
  function addLabel(f){ var b=window.MT_CONFIG_I18N.label(baseLabel(f.label))||window.MT_CONFIG_I18N.text("ui_3eb1fb64e3ad_html", "le champ"); return window.MT_CONFIG_I18N.text("ui_409da49307ed_html", "Ajouter ")+b.toLowerCase(); }
  function fieldRowHTML(f){
    var ph=placeholderFor(f), del=(!!f.deletable && !f.required), dropped=isDropped(f.el);
    var kase=f.kase||(f.upper?'upper':''), inp;
    if(f.input==='date'){
      inp='<input class="mtp-fin mtp-fdate" type="date" data-fk="'+esc(f.key)+'" value="'+esc(fval(f.key))+'" autocomplete="off">';
    } else if(f.input==='number'){
      inp='<input class="mtp-fin" type="text" inputmode="decimal" data-num="1" data-fk="'+esc(f.key)+'" value="'+esc(fval(f.key))+'" placeholder="'+esc(ph)+'" autocomplete="off" spellcheck="false" enterkeyhint="next">';
    } else {
      var st=(kase==='upper'?' style="text-transform:uppercase"':(kase==='lower'?' style="text-transform:lowercase"':''));
      inp='<input class="mtp-fin" type="text"'+(kase?' data-case="'+kase+'"':'')+st+' data-fk="'+esc(f.key)+'" value="'+esc(fval(f.key))+'" placeholder="'+esc(ph)+'" autocomplete="off" spellcheck="false" enterkeyhint="next">';
    }
    return '<div class="mtp-f'+(dropped?' is-dropped':'')+'" data-fwrap="'+f.el+'">'+inp
      +(del?'<button class="mtp-fx" type="button" tabindex="-1" data-dropel="'+f.el+window.MT_CONFIG_I18N.text("ui_2059900f33eb_html", "\" aria-label=\"Retirer ce champ\" title=\"Retirer ce champ\"></button>"):((!!f.group)?'<span class="mtp-fxsp" aria-hidden="true"></span>':''))
      +(del?'<button class="mtp-fadd" type="button" tabindex="-1" data-addel="'+f.el+'">+ '+escHtml(addLabel(f))+'</button>':'')
      +'</div>';
  }
  function optionsHTML(st){
    var h='';
    if(st.shapes.length>1){
      h+='<div class="mtp-shapes">'+st.shapes.map(function(sp){var sh=SHAPES[sp]||SHAPES.carree;return '<button class="mtp-shapebtn'+(state.shape===sp?' mtp-on':'')+'" type="button" data-shape="'+sp+'"><span class="mtp-sht"><span class="mtp-shic '+(sh.cls==='sq'?'mtp-sqic':'mtp-hex')+'"></span>'+esc(SHAPE_LABELS[sp]||window.MT_CONFIG_I18N.label(sh.label))+'</span><span class="mtp-shm">'+sh.dim+'</span></button>';}).join('')+'</div>';
    }
    if(st.holes.indexOf(1)>=0){
      h+='<div class="mtp-optline"><div class="mtp-optrow'+(state.hole?' mtp-on':'')+window.MT_CONFIG_I18N.text("ui_50af9d5542ce_html", "\" id=\"mtpHole\"><span class=\"mtp-optbox\"></span><span class=\"mtp-opttx\">Trou de suspension<span class=\"mtp-optsub\">Pour l'accrocher à un mur ou une porte</span></span><span class=\"mtp-optpl\" id=\"mtpHolePl\"></span></div></div>");
    }
    return h;
  }
  function uniqueShapes(){ var o=[]; VARR.forEach(function(v){var sp=v.k.split('|')[0]; if(o.indexOf(sp)<0)o.push(sp);}); return o.length?o:['carree']; }
  function uniqueHoles(){ var o=[]; VARR.forEach(function(v){var hh=+v.k.split('|')[1]; if(o.indexOf(hh)<0)o.push(hh);}); return o; }
  var STEPS=[];
  function buildSteps(){
    var steps=[], i=0;
    while(i<FIELDS.length){
      var f=FIELDS[i];
      if(f.group){
        var gid=f.group, arr=[];
        while(i<FIELDS.length && FIELDS[i].group===gid){ arr.push(FIELDS[i]); i++; }
        steps.push({type:'group', title:groupTitle(arr), fields:arr, _order:(arr[0].order==null?999:arr[0].order), _idx:arr[0].el});
      } else {
        var el0=f.el, arr2=[];
        while(i<FIELDS.length && !FIELDS[i].group && FIELDS[i].el===el0){ arr2.push(FIELDS[i]); i++; }
        var ttl=(f.tlabel&&String(f.tlabel).trim())?f.tlabel:f.label;
        steps.push({type:'field', title:ttl, fields:arr2, _order:(f.order==null?999:f.order), _idx:f.el});
      }
    }
    LOGOFIELDS.forEach(function(lf){ steps.push({type:'logo', title:lf.label, logo:lf, _order:(lf.order==null?999:lf.order), _idx:lf.el}); });
    steps.sort(function(a,b){ return (a._order-b._order)||(a._idx-b._idx); });
    (function(){ var lt=0; steps.forEach(function(s){ if(s.type==='logo')lt++; }); var ln=0; steps.forEach(function(s){ if(s.type==='logo'){ ln++; if(!s.title) s.title=(lt>1)?(window.MT_CONFIG_I18N.text("ui_6736e4255b98_html", "Personnalisez votre motif ")+ln+'/'+lt):window.MT_CONFIG_I18N.text("ui_3eabd9520853_html", "Personnalisez votre motif"); } }); })();
    var shapes=uniqueShapes(), holes=uniqueHoles();
    if(shapes.length>1 || holes.indexOf(1)>=0){ steps.push({type:'options', title:window.MT_CONFIG_I18N.text("ui_ebfe9eaaa8d5_html", "La forme & les options"), fields:[], shapes:shapes, holes:holes}); }
    return steps;
  }
  function buildForm(){
    FIELDS=collectFields(); LOGOFIELDS=collectLogoFields(); STEPS=buildSteps();
    var box=$('mtpSteps'), h='';
    STEPS.forEach(function(st,si){
      h+='<div class="mtp-step is-locked" data-step="'+si+'" data-type="'+st.type+'">';
      h+='<div class="mtp-stephead"><span class="mtp-stepnum">'+(si+1)+'</span><span class="mtp-steptitle">'+escHtml(window.MT_CONFIG_I18N.label(st.title))+'</span></div>';
      h+='<div class="mtp-stepbody">';
      if(st.type==='options') h+=optionsHTML(st);
      else if(st.type==='logo') h+=logoChooserHTML(st);
      else st.fields.forEach(function(f){ h+=fieldRowHTML(f); });
      h+='</div></div>';
    });
    box.innerHTML=h;
    wireForm();
    reveal(true);
  }
  function wireForm(){
    Array.prototype.forEach.call(formEl.querySelectorAll('input.mtp-fin'),function(inp){
      inp.addEventListener('input',function(){ var cs;
        if(inp.getAttribute('data-num')==='1'){ var p=inp.selectionStart, nv=inp.value.replace(/[^0-9.,]/g,'').replace(/([.,])(?=.*[.,])/g,''); if(nv!==inp.value){ inp.value=nv; try{inp.setSelectionRange(Math.max(0,p-1),Math.max(0,p-1));}catch(_){} } }
        else if((cs=inp.getAttribute('data-case'))){ var s=inp.selectionStart; inp.value=(cs==='lower')?inp.value.toLowerCase():inp.value.toUpperCase(); try{inp.setSelectionRange(s,s);}catch(_){} }
        state.values[inp.getAttribute('data-fk')]=inp.value; inp.classList.remove('mtp-fin-err'); if(_revealLive)_revealLive(); rebake(); reveal(true); preloadCfg(); });
      inp.addEventListener('change',function(){ state.values[inp.getAttribute('data-fk')]=inp.value; if(_revealLive)_revealLive(); rebake(); reveal(true); });
      inp.addEventListener('keydown',function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); var ins=Array.prototype.slice.call(formEl.querySelectorAll('input.mtp-fin')).filter(function(x){return x.offsetParent!==null;}); var k=ins.indexOf(inp), nx=ins[k+1]; if(nx){try{nx.focus();}catch(_){}}else{try{inp.blur();}catch(_){}} } });
    });
    Array.prototype.forEach.call(formEl.querySelectorAll('.mtp-fx[data-dropel]'),function(b){
      b.addEventListener('click',function(){ if(_revealLive)_revealLive(); var idx=+b.getAttribute('data-dropel'); state.dropped[idx]=true; var w=b.closest('.mtp-f'); if(w)w.classList.add('is-dropped'); rebake(); reveal(); });
    });
    Array.prototype.forEach.call(formEl.querySelectorAll('.mtp-fadd[data-addel]'),function(b){
      b.addEventListener('click',function(){ if(_revealLive)_revealLive(); var idx=+b.getAttribute('data-addel'); state.dropped[idx]=false; var w=b.closest('.mtp-f'); if(w){ w.classList.remove('is-dropped'); var inp=w.querySelector('input.mtp-fin'); if(inp){try{inp.focus();}catch(_){}} } rebake(); reveal(); });
    });
    Array.prototype.forEach.call(formEl.querySelectorAll('[data-shape]'),function(b){
      b.addEventListener('click',function(){ if(_revealLive)_revealLive(); state.shape=b.getAttribute('data-shape'); Array.prototype.forEach.call(formEl.querySelectorAll('[data-shape]'),function(x){x.classList.toggle('mtp-on',x===b);}); getBgImg((SHAPES[state.shape]||SHAPES.carree).cls==='sq'); refreshHolePrice(); rebake(); });
    });
    Array.prototype.forEach.call(formEl.querySelectorAll('.mtp-logobtn[data-swapel]'),function(b){
      b.addEventListener('click',function(){ if(_revealLive)_revealLive();
        var idx=+b.getAttribute('data-swapel'), key=b.getAttribute('data-swapkey'), row=b.parentNode;
        Array.prototype.forEach.call(row.querySelectorAll('.mtp-logobtn'),function(x){ var on=(x===b); x.classList.toggle('mtp-on',on); x.setAttribute('aria-pressed',on?'true':'false'); });
        function apply(){ state.swaps[idx]=key; rebake(); reveal(); }
        /* Le bouton reagit tout de suite ; la tomette change des que le dessin
           est disponible. Sans cette attente on graverait le coeur de repli. */
        if(LOGOCAT[key]&&LOGOCAT[key].svg){ apply(); }
        else { b.classList.add('mtp-loading'); ensureLogoSvg(key).then(function(){ b.classList.remove('mtp-loading'); apply(); }); } });
      b.addEventListener('pointerenter',function(){ var k=b.getAttribute('data-swapkey');
        if(!(LOGOCAT[k]&&LOGOCAT[k].svg))ensureLogoSvg(k); },{passive:true});
    });
    var holeEl=$('mtpHole'); if(holeEl)holeEl.addEventListener('click',function(){ if(_revealLive)_revealLive(); state.hole=!state.hole; this.classList.toggle('mtp-on',state.hole); rebake(); });
    refreshHolePrice();
  }
  function refreshHolePrice(){ var pl=$('mtpHolePl'); if(!pl)return; var wi=VARIANTS[state.shape+'|1'], no=VARIANTS[state.shape+'|0']; if(wi&&no){var d=Math.round(wi.price-no.price); pl.textContent=d>0?('+'+displayEuro(d)):'';} else pl.textContent=''; }
  /* ===== révélation progressive : étapes faites/active en noir, à venir en gris (champs masqués) ===== */
  function stepComplete(st){
    if(st.type!=='group'&&st.type!=='field')return true;
    return st.fields.every(function(f){ return !f.required || isDropped(f.el) || fval(f.key).trim(); });
  }
  function reveal(noFocus){
    var box=$('mtpSteps'); if(!box)return; var nodes=box.children, i;
    var firstInc=STEPS.length;
    for(i=0;i<STEPS.length;i++){ if(!stepComplete(STEPS[i])){ firstInc=i; break; } }
    for(i=0;i<nodes.length;i++){ var cl=nodes[i].classList; cl.remove('is-locked','is-active','is-done'); cl.add(i<firstInc?'is-done':(i===firstInc?'is-active':'is-locked')); }
    if(!noFocus && firstInc>reveal._last && firstInc<STEPS.length){
      var node=nodes[firstInc];
      if(node && node.getAttribute('data-type')!=='options'){ var inp=node.querySelector('input.mtp-fin'); if(inp){ try{inp.focus();}catch(_){} } }
    }
    reveal._last=firstInc;
    updateCTA();
  }
  reveal._last=-1;

  formEl.addEventListener('focusin',function(e){ if(e.target&&e.target.tagName==='INPUT') hero.classList.add('mtp-editing'); });
  formEl.addEventListener('focusout',function(){ setTimeout(function(){ if(!formEl.querySelector('input:focus')) hero.classList.remove('mtp-editing'); },70); });

  $('mtpQMinus').addEventListener('click',function(){if(qty>1){qty--;refreshQty();}});
  $('mtpQPlus').addEventListener('click',function(){if(qty<99){qty++;refreshQty();}});
  function refreshQty(){$('mtpQVal').textContent=qty;$('mtpQMinus').disabled=(qty<=1);updatePriceUI();updateCTA();}
  $('mtpAdd').addEventListener('click',addToCart);

  /* (ancien assistant pas-à-pas remplacé par la révélation progressive ci-dessus) */

  /* ============================ ATELIER — popup configurateur ============================ */
  /* Méthode identique au panier / fiche produit en ligne : le configurateur lit la recette
     dans le HASH de l'URL (#d=<recette>). On récupère son HTML par fetch, on y injecte un
     <base> + un <script> qui pose le hash, puis on le charge en srcdoc ou en
     about:blank même origine (Safari). Dialogue par {mtcfg:'close'|'nav'}. */
  var CFG_PATH=window.MT_CONFIG_I18N.url("/pages/configurateur-app");
  var cfgHtmlCache=null, cfgFetching=false, cfgBlobUrl=null, _cfgHideT=null;
  var cfgFrame=null, cfgReady=false, cfgGeneration=0;
  function preloadCfg(){
    if(cfgHtmlCache||cfgFetching)return; cfgFetching=true;
    fetch(CFG_PATH,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():null;}).then(function(html){if(html)cfgHtmlCache=html;cfgFetching=false;}).catch(function(){cfgFetching=false;});
  }
  function isSafari(){var ua=navigator.userAgent;return /iP(ad|hone|od)/.test(ua)||(/safari/i.test(ua)&&!/chrome|android|crios|fxios|edg/i.test(ua));}
  function buildCfgDoc(raw,hash){
    var head='<base href="'+location.origin+'/">';
    if(hash){head+='<scr'+'ipt>try{location.hash='+JSON.stringify(hash)+';}catch(e){}</scr'+'ipt>';}
    var out=raw.replace(/<head([^>]*)>/i,function(m,a){return '<head'+a+'>'+head;});
    if(out===raw)out=head+raw;
    return out;
  }
  function makeCfgFrame(){
    var wrap=$('mtpCfgFrameWrap'); wrap.innerHTML='';
    var f=document.createElement('iframe'); f.className='mtp-cfg-frame'; f.title=window.MT_CONFIG_I18N.text("ui_4ac82d575a86_html", "Atelier de personnalisation MyTomette"); f.setAttribute('allow','fullscreen');
    wrap.appendChild(f); cfgFrame=f; cfgReady=false; return f;
  }
  function hideCfgLoading(){ if(_cfgHideT){clearTimeout(_cfgHideT);_cfgHideT=null;} $('mtpCfgLoading').classList.add('mtp-hide'); }
  function openConfig(){
    var host=$('mtpCfgHost'), loading=$('mtpCfgLoading');
    if(host.classList.contains('mtp-open'))return;
    /* Remonté sous <body> : sinon le host reste prisonnier du contexte d'empilement de la
       section produit (position:sticky, z-index:1) et passe SOUS le header/menu du thème.
       Directement sous <body> + z-index maximal (voir CSS body > .mtp-cfg-host) -> au-dessus de tout. */
    if(host.parentNode!==document.body){ document.body.appendChild(host); }
    var hash='#d='+_b64enc(JSON.stringify(getRecipe(true)));   // EXPERT : éléments de la recette d'origine (valeurs saisies ou exemple)
    var generation=++cfgGeneration;
    loading.classList.remove('mtp-hide');
    host.classList.add('mtp-open'); host.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    function go(raw){
      if(generation!==cfgGeneration||!host.classList.contains('mtp-open'))return;
      var html=buildCfgDoc(raw,hash), f=makeCfgFrame();
      f.onload=function(){ if(cfgFrame!==f)return; hideCfgLoading(); };
      _cfgHideT=setTimeout(hideCfgLoading,1800);
      if(isSafari()){
        var ok=false;
        try{var sdoc=f.contentWindow.document;sdoc.open();sdoc.write(html);sdoc.close();ok=true;}catch(e){}
        if(!ok){try{f.srcdoc=html;}catch(e2){}}
      }else{
        f.srcdoc=html;
      }
    }
    if(cfgHtmlCache){go(cfgHtmlCache);}
    else{
      fetch(CFG_PATH,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():null;}).then(function(html){
        if(generation!==cfgGeneration)return;
        if(html){cfgHtmlCache=html;go(html);}else{toast(window.MT_CONFIG_I18N.text("ui_9311fc1f7b54_html", "Atelier momentanément indisponible"));closeConfig();}
      }).catch(function(){if(generation!==cfgGeneration)return;toast(window.MT_CONFIG_I18N.text("ui_9311fc1f7b54_html", "Atelier momentanément indisponible"));closeConfig();});
    }
  }
  function closeConfig(approved){
    if(cfgFrame&&approved!==true){requestCloseConfig();return;}
    var host=$('mtpCfgHost');
    cfgGeneration++; cfgFrame=null; cfgReady=false;
    host.classList.remove('mtp-open'); host.setAttribute('aria-hidden','true');
    if(cfgBlobUrl){try{URL.revokeObjectURL(cfgBlobUrl);}catch(e){}cfgBlobUrl=null;}
    try{$('mtpCfgFrameWrap').innerHTML='';}catch(e){}
    if(_cfgHideT){clearTimeout(_cfgHideT);_cfgHideT=null;}
    document.documentElement.style.overflow='';
  }
  function requestCloseConfig(){
    if(!$('mtpCfgHost').classList.contains('mtp-open'))return;
    // Missing progress is never permission to discard an installed editor.
    if(!cfgFrame){ closeConfig(); return; }
    try{if(typeof cfgFrame.contentWindow._mtAskClose==='function'){cfgFrame.contentWindow._mtAskClose();if(cfgFrame)cfgFrame.__mtCloseAskedAt=0;return;}}catch(e){}
    var now=Date.now();
    if(cfgFrame.__mtCloseAskedAt && now-cfgFrame.__mtCloseAskedAt>=2000){
      cfgFrame.__mtCloseAskedAt=0;
      if(window.confirm(/^en\b/i.test((window.MT_CONFIG_I18N||{}).locale||document.documentElement.lang||'') ? 'The editor is not responding. Leave without saving? Your design may be lost.' : /^es\b/i.test((window.MT_CONFIG_I18N||{}).locale||document.documentElement.lang||'') ? 'El editor no responde. ¿Salir sin guardar? Podrías perder tu creación.' : 'L’éditeur ne répond pas. Quitter sans enregistrer ? Votre création risque d’être perdue.')) closeConfig(true);
      return;
    }
    if(!cfgFrame.__mtCloseAskedAt)cfgFrame.__mtCloseAskedAt=now;
    try{cfgFrame.contentWindow.postMessage({mtcfg:'requestClose'},'*');}catch(e){}
  }
  window.addEventListener('message',function(ev){
    if(!$('mtpCfgHost').classList.contains('mtp-open')||!cfgFrame||ev.source!==cfgFrame.contentWindow)return;
    var d=ev&&ev.data;
    if(d&&d.mtcfg==='step'){ cfgReady=true; }
    if(d==='mtcfg-close'||(d&&d.mtcfg==='close')){ closeConfig(true); return; }
    if(d&&d.mtcfg==='step'){ var p=$('mtpCfgProg'); if(p){ var seg=p.querySelectorAll('i'); var n=d.step||1; for(var i=0;i<seg.length;i++){ seg[i].classList.toggle('on', i<n); } } return; }
    if(d&&d.mtcfg==='nav'&&typeof d.url==='string'){ window.location.href=d.url; return; }
  });
  $('mtpAtelier').addEventListener('click',function(e){e.preventDefault();openConfig();});
  $('mtpCfgClose').addEventListener('click',requestCloseConfig);
  $('mtpCfgHost').addEventListener('click',function(e){if(e.target===this)requestCloseConfig();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&$('mtpCfgHost').classList.contains('mtp-open'))requestCloseConfig();});
  /* Cale l'aperçu épinglé juste sous l'en-tête du thème quand il reste affiché (sticky/fixed). */
  function mtpSyncStickyTop(){
    try{
      var root=$('mtp')||document.getElementById('mtp'); if(!root)return;
      if(!window.matchMedia('(max-width:880px)').matches){root.style.setProperty('--mtp-sticky-top','0px');return;}
      var sel='header,[role="banner"],.header,.header-wrapper,.site-header,.shopify-section-header,#shopify-section-header,.section-header,.header__wrapper,.header-group,sticky-header';
      var off=0;
      document.querySelectorAll(sel).forEach(function(el){
        if(el.closest&&el.closest('#mtp'))return;            /* ignore notre propre section */
        var cs=getComputedStyle(el);
        if(cs.position==='fixed'||cs.position==='sticky'){
          var r=el.getBoundingClientRect();
          if(r.top<=4&&r.height>4&&r.bottom>off)off=r.bottom; /* en-tête réellement collé en haut */
        }
      });
      root.style.setProperty('--mtp-sticky-top',Math.max(0,Math.round(off))+'px');
    }catch(e){}
  }
  mtpSyncStickyTop();
  [250,900,1800].forEach(function(t){setTimeout(mtpSyncStickyTop,t);});
  window.addEventListener('resize',mtpSyncStickyTop);
  var _mtpST=false;
  window.addEventListener('scroll',function(){if(_mtpST)return;_mtpST=true;requestAnimationFrame(function(){_mtpST=false;mtpSyncStickyTop();});},{passive:true});
  window.addEventListener('resize',scheduleLive);

  /* ============================ APERÇU LIVE DANS LA GALERIE ============================ */
  /* Sur desktop : on superpose l'aperçu live à la photo principale de la galerie du thème,
     avec une bascule « Voir les photos / Revenir à l'aperçu ». Les vraies photos restent
     accessibles via les miniatures natives. Sur mobile : on garde l'aperçu collant du moteur
     et on masque la galerie native (pas de doublon). */
  function mtpPhotoUrl(raw,width){
    try{
      var u=new URL(raw,location.href);
      if(u.hostname==='cdn.shopify.com'||u.pathname.indexOf('/cdn/shop/')===0){
        u.pathname=u.pathname.replace(/_(?:\d+x\d*|x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.[a-zA-Z0-9]+)$/i,'$1');
        u.searchParams.set('width',String(width));
      }
      return u.href;
    }catch(e){return raw;}
  }
  function mtpPhotoKey(raw){
    try{
      var u=new URL(raw,location.href);
      return u.hostname+u.pathname.replace(/_(?:\d+x\d*|x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.[a-zA-Z0-9]+)$/i,'$1');
    }catch(e){return raw.split(/[?#]/)[0];}
  }
  function mtpPhotoFromImage(im){
    var raw=im.getAttribute('data-full-src')||im.getAttribute('data-display-src')||im.getAttribute('data-mt-native-src')||im.currentSrc||im.getAttribute('src')||'';
    if(!raw||/^(?:data|blob):/i.test(raw))return null;
    return {
      key:mtpPhotoKey(raw),
      displaySrc:im.getAttribute('data-display-src')||mtpPhotoUrl(raw,1200),
      fullSrc:im.getAttribute('data-full-src')||mtpPhotoUrl(raw,1800),
      thumbSrc:mtpPhotoUrl(raw,120),
      srcset:im.getAttribute('srcset')||im.getAttribute('data-mt-native-srcset')||'',
      sizes:im.getAttribute('sizes')||'',
      width:im.getAttribute('width')||'',
      height:im.getAttribute('height')||'',
      alt:im.getAttribute('alt')||''
    };
  }
  function mtpCollectPhotos(gal,primary){
    var out=[], seen={};
    function add(im){
      var photo=mtpPhotoFromImage(im);
      if(!photo||seen[photo.key])return;
      seen[photo.key]=true;out.push(photo);
    }
    if(primary)add(primary);
    var scope=gal.querySelector('slideshow-slides')||gal.querySelector('[class*="slideshow-slides"]')||gal.querySelector('.product-media-container')||gal;
    Array.prototype.forEach.call(scope.querySelectorAll('img'),add);
    return out;
  }
  function mtpRealPhoto(tile,photo){
    var im=tile.querySelector('img.mtp-realphoto[data-mtp-photo-ssr]')||tile.querySelector('img.mtp-realphoto');
    if(!im){
      if(!photo)return null;
      im=document.createElement('img');im.className='mtp-realphoto';im.decoding='async';im.alt=photo.alt;
      if(photo.width)im.setAttribute('width',photo.width);
      if(photo.height)im.setAttribute('height',photo.height);
      if(photo.srcset)im.setAttribute('srcset',photo.srcset);
      if(photo.sizes)im.setAttribute('sizes',photo.sizes);
      im.setAttribute('fetchpriority','high');
      im.src=photo.displaySrc;
    }
    if(photo){
      im.setAttribute('data-display-src',photo.displaySrc);
      im.setAttribute('data-full-src',photo.fullSrc);
    }
    return im;
  }
  function mtpReady(){
    var root=$('mtp');
    if(!root||root.getAttribute('data-mtp-ready')==='1')return;
    root.setAttribute('data-mtp-ready','1');
    document.dispatchEvent(new CustomEvent('mtp:ready',{detail:{root:root}}));
  }
  function mtpInitGallery(tries){
    var sec=document.getElementById('mtp'); if(!sec)return;
    var gal=document.querySelector('media-gallery, .product-media-gallery, [class*="media-gallery"]');
    var tile=$('mtpTile');
    if(!gal||!tile){ if((tries||0)<14){ setTimeout(function(){mtpInitGallery((tries||0)+1);},250); } return; }
    if(sec.getAttribute('data-mtp-gal')==='1')return; sec.setAttribute('data-mtp-gal','1');
    var host=gal.querySelector('slideshow-container')||gal.querySelector('.product-media-container')||gal;
    var origParent=tile.parentNode;
    var mqD=window.matchMedia('(min-width:881px)');
    var PHOTOS=mtpCollectPhotos(gal,tile.querySelector('img.mtp-realphoto[data-mtp-photo-ssr]')).slice(0,4);
    try{ gal.classList.add('mtp-gal-skinned'); }catch(e){}
    /* section produit + grille commune (galerie+détails) pour fond #F9F9F9 et colonnes resserrées comme la page prénom */
    var ssec=sec.closest?sec.closest('.shopify-section'):null;
    var gridLCA=null;
    try{ var anc=[],a=gal; while(a){anc.push(a);a=a.parentNode;} var b=sec; while(b){ if(anc.indexOf(b)>=0){gridLCA=b;break;} b=b.parentNode; } }catch(e){}
    var grTpl0=null;
    function mtpStylePage(narrow){
      try{ if(ssec){ ssec.style.setProperty('background-color','#F9F9F9','important'); var pp=ssec.parentNode; if(pp&&pp.style)pp.style.setProperty('background-color','#F9F9F9','important'); } }catch(e){}
      if(!gridLCA)return;
      if(narrow){
        gridLCA.style.maxWidth='1080px'; gridLCA.style.marginLeft='auto'; gridLCA.style.marginRight='auto';
        try{ if(getComputedStyle(gridLCA).display==='grid'){ if(grTpl0===null)grTpl0=gridLCA.style.gridTemplateColumns||''; gridLCA.style.gridTemplateColumns='minmax(0,1fr) minmax(0,1fr)'; gridLCA.style.columnGap='40px'; } }catch(e){}
      } else {
        gridLCA.style.maxWidth=''; gridLCA.style.marginLeft=''; gridLCA.style.marginRight='';
        if(grTpl0!==null){ gridLCA.style.gridTemplateColumns=grTpl0; gridLCA.style.columnGap=''; }
      }
    }

    /* carte beige (couvre la galerie native) */
    var ov=document.createElement('div'); ov.className='mtp-galov';
    var cap=document.createElement('div'); cap.className='mtp-galcap'; cap.innerHTML=window.MT_CONFIG_I18N.text("ui_fac4c62a40c5_html", "<span class=\"mtp-capa\">Composez votre tomette</span><span class=\"mtp-capb\">l’aperçu se grave en direct</span>");
    /* photo réelle d'abord (1re photo produit) -> masquée à la 1re personnalisation */
    var realimg=mtpRealPhoto(tile,PHOTOS[0]);


    /* lightbox (popup) — photos catalogue + aperçu live */
    var lb=document.createElement('div'); lb.className='mtp-lightbox'; lb.setAttribute('aria-hidden','true');
    lb.innerHTML=window.MT_CONFIG_I18N.text("ui_2991d2d7f48e_html", "<div class=\"mtp-lb-box\"><button class=\"mtp-lb-close\" type=\"button\" aria-label=\"Fermer\">✕</button><button class=\"mtp-lb-nav mtp-lb-prev\" type=\"button\" aria-label=\"Précédente\">‹</button><img alt=\"\"><button class=\"mtp-lb-nav mtp-lb-next\" type=\"button\" aria-label=\"Suivante\">›</button></div>");
    sec.appendChild(lb);
    var lbi=lb.querySelector('img'), lbIdx=0;
    var lbShow=function(i){ if(!PHOTOS.length)return; lbIdx=(i+PHOTOS.length)%PHOTOS.length; lbi.src=PHOTOS[lbIdx].fullSrc;lbi.alt=PHOTOS[lbIdx].alt; };
    var lbClose=function(){ lb.classList.remove('mtp-on'); lb.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; };
    var lbWrap=function(){ lb.classList.add('mtp-on'); lb.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; };
    lb.querySelector('.mtp-lb-close').addEventListener('click',lbClose);
    lb.querySelector('.mtp-lb-prev').addEventListener('click',function(e){e.stopPropagation();lbShow(lbIdx-1);});
    lb.querySelector('.mtp-lb-next').addEventListener('click',function(e){e.stopPropagation();lbShow(lbIdx+1);});
    lb.addEventListener('click',function(e){ if(e.target===lb)lbClose(); });
    document.addEventListener('keydown',function(e){ if(!lb.classList.contains('mtp-on'))return; if(e.key==='Escape')lbClose(); else if(e.key==='ArrowLeft'){if(!lb.classList.contains('mtp-single'))lbShow(lbIdx-1);} else if(e.key==='ArrowRight'){if(!lb.classList.contains('mtp-single'))lbShow(lbIdx+1);} });
    var LB={ open:function(i){ if(!PHOTOS.length)return; lb.classList.remove('mtp-single'); lbShow(i); lbWrap(); },
             openSrc:function(src){ lb.classList.add('mtp-single'); lbi.src=src; lbWrap(); } };
    /* clic sur la tomette personnalisée -> aperçu live en grand (popup) */
    tile.style.cursor='zoom-in';
    tile.addEventListener('click',function(){
      if(realimg && !realimg.classList.contains('mtp-hide')) return;   /* mode photo : géré par la photo réelle */
      try{ var cv=$('mtpCanvas'); if(cv){ LB.openSrc(cv.toDataURL('image/png')); } }catch(e){}
    });
    /* vignettes = photos de la fiche produit -> ouvrent la lightbox */
    if(realimg){ realimg.addEventListener('click',function(){
      var key=mtpPhotoKey(realimg.getAttribute('data-full-src')||realimg.currentSrc||realimg.src);
      var idx=PHOTOS.findIndex(function(photo){return photo.key===key;});
      if(LB)LB.open(idx<0?0:idx);
    }); }
    var thumbs=document.createElement('div'); thumbs.className='mtp-thumbs';
    PHOTOS.forEach(function(photo,i){
      var b=document.createElement('button'); b.type='button'; b.className='mtp-thumb'; b.setAttribute('aria-label',window.MT_CONFIG_I18N.text('ui_b31bc6bead9e_html','Agrandir la photo ')+(i+1));
      var im=document.createElement('img');im.width=60;im.height=60;im.src=photo.thumbSrc;im.alt='';im.loading='lazy';im.decoding='async';
      [b,im].forEach(function(el){
        el.setAttribute('data-display-src',photo.displaySrc);el.setAttribute('data-full-src',photo.fullSrc);
        el.setAttribute('data-srcset',photo.srcset);el.setAttribute('data-sizes',photo.sizes);
      });
      b.appendChild(im);
      b.addEventListener('click',function(){ if(LB)LB.open(i); });
      thumbs.appendChild(b);
    });

    /* 1re personnalisation -> on révèle l'aperçu live (masque la photo réelle + la légende) */
    _revealLive=function(){ if(realimg)realimg.classList.add('mtp-hide'); cap.classList.add('mtp-galcap-hidden'); scheduleLive(); };

    function apply(){
      if(mqD.matches){
        mtpStylePage(true);
        gal.classList.remove('mtp-galhide-mobile');
        sec.classList.add('mtp-takeover');
        if(tile.parentNode!==ov) ov.appendChild(tile);
        if(realimg&&realimg.parentNode!==ov) ov.appendChild(realimg);
        if(cap.parentNode!==ov) ov.appendChild(cap);
        if(ov.parentNode!==gal) gal.insertBefore(ov, gal.firstChild);
        if(thumbs.parentNode!==gal) gal.appendChild(thumbs);
      } else {
        mtpStylePage(false);
        sec.classList.remove('mtp-takeover');
        if(tile.parentNode!==origParent) origParent.appendChild(tile);
        if(realimg&&realimg.parentNode!==tile) tile.appendChild(realimg);   /* DANS la tomette -> photo calée pile sur le cadre (même taille que le live) */
        if(cap.parentNode!==origParent) origParent.appendChild(cap);
        var stage=document.querySelector('#mtp .mtp-stage');
        if(stage&&thumbs.parentNode!==stage){ stage.appendChild(thumbs); }   /* dans le stage (sticky) -> vignettes en absolu à gauche, superposées */
        gal.classList.add('mtp-galhide-mobile');
      }
      scheduleLive();
      document.dispatchEvent(new CustomEvent('mtp:gallery-ready',{detail:{root:sec}}));
    }
    if(mqD.addEventListener)mqD.addEventListener('change',apply); else if(mqD.addListener)mqD.addListener(apply);
    apply();
  }

  /* ============================ INIT ============================ */
  buildFonts(RECIPE.fonts||[]);
  seedRecipeLogos();
  initLinkedVariant();
  (function(){ var h=location.hash||'';
    var mg=h.match(/[#&]g=([^&]+)/);
    if(mg){ try{ var st=JSON.parse(_b64dec(mg[1])); if(st){ if(st.vals&&typeof st.vals==='object')state.values=st.vals; if(st.shape&&SHAPES[st.shape])state.shape=st.shape; if(typeof st.hole!=='undefined')state.hole=!!st.hole; if(st.dropped&&typeof st.dropped==='object')state.dropped=st.dropped; } }catch(e){} }
    var mk=h.match(/[#&]k=([^&]+)/); if(mk){ try{EDIT_KEY=decodeURIComponent(mk[1]);}catch(e){EDIT_KEY=mk[1];} }
  })();
  initRO();
  getBgImg((SHAPES[state.shape]||SHAPES.carree).cls==='sq');
  /* Precharge UNIQUEMENT le dessin affiche sur la tomette. Les logos optionnels
     sont decodes a la demande par getLogoImg() pendant le dessin : scheduleLive()
     redessine des que l'image est prete. Precharger les 34 options coutait
     ~1,2 s de blocage du thread principal au chargement. */
  (function(){ var seen={}; (RECIPE.elements||[]).forEach(function(el){ if(el.type==='logo'&&!seen[el.logo]){seen[el.logo]=1;getLogoImg(el.logo);} }); })();
  injectRecipeFonts(); loadLogos(); loadFontsCdn();
  buildForm();
  /* Vignettes : on tente les previews (legeres, cachables). Filet de securite a
     2,5 s : si le manifeste ne repond pas, on retombe sur le SVG inline plutot
     que de laisser des boutons vides. Les previews reprennent la main si elles
     arrivent ensuite. */
  loadPreviews().then(refreshLogoThumbs);
  setTimeout(function(){ if(_prevState!==2)_prevState=2; refreshLogoThumbs(); },2500);
  if(MODE==='both'){ var aw=$('mtpAtelierWrap'); if(aw)aw.style.display=''; }
  rebake();
  refreshQty();
  reveal(true);
  mtpInitGallery(0);

  /* ── LABO · Atelier mobile : lecture seule de l'état cuit ──────────
     Les positions des lignes bougent au bake (les prénoms se recentrent
     selon leur nombre) : l'Atelier lit ici où chaque élément est
     réellement dessiné. Une fonction, zéro écriture. */
  try{ window.__MTA_ETAT__ = function(){ return { els: state.els, shape: state.shape, hole: state.hole }; }; }catch(e){}
  try{ window.__MTA_MESURE__ = function(taille){ return sizeCqwFor(taille, state.shape) / 100; }; }catch(e){}
  try{ window.__MTA_POLICE__ = function(id, poids){ return engraveCss(id, poids || 600); }; }catch(e){}
  try{ window.__MTA_REDESSINE__ = scheduleLive; }catch(e){}
  try{ window.__MTA_TARIF__ = function(sh, avecTrou){ var ho=(avecTrou==null)?(state.hole?1:0):(avecTrou?1:0); var v=VARIANTS[sh+'|'+ho]||VARIANTS[sh+'|0']; return (v&&v.price!=null)?v.price:null; }; }catch(e){}
  /* LABO Atelier mobile : ou la gravure atterrit-elle DANS le cadre ?
     Reproduit le calage de renderTileTo : carre -> bbox du carreau dans la
     photo ; hexagone -> CLEAN_HEX dans la photo contain. Fractions du cadre. */
  try{ window.__MTA_CARTE__ = function(){
    var out={x0:0,y0:0,kx:1,ky:1};
    try{
      var box=$('mtpTile'); if(!box)return out;
      var r=box.getBoundingClientRect(), W=r.width||1, H=r.height||1;
      var sq=(SHAPES[state.shape]||SHAPES.hexa).cls==='sq', bg=getBgImg(sq);
      if(bg&&bg.img&&(bg.img.naturalWidth||bg.img.width)){
        if(sq){ var rc=containRect(bg.img,W,H), sb=squareTileBox(bg.img);
          out={x0:(rc.x+sb.x0*rc.w)/W, y0:(rc.y+sb.y0*rc.h)/H, kx:((sb.x1-sb.x0)*rc.w)/W, ky:((sb.y1-sb.y0)*rc.h)/H}; }
        else if(bg.full){ var rcf=containRect(bg.full,W,H);
          out={x0:(rcf.x+CLEAN_HEX.x0*rcf.w)/W, y0:(rcf.y+CLEAN_HEX.y0*rcf.h)/H, kx:((CLEAN_HEX.x1-CLEAN_HEX.x0)*rcf.w)/W, ky:((CLEAN_HEX.y1-CLEAN_HEX.y0)*rcf.h)/H}; }
      }
    }catch(e){}
    return out;
  }; }catch(e){}
  /* LABO Atelier mobile : deux mesures pour suivre le texte au doigt —
     la largeur reellement gravee d'une ligne (le fond clair colle au
     texte a chaque frappe), et le caractere le plus proche d'un point
     (le curseur se pose la ou le doigt touche). Toutes les valeurs sont
     des fractions du canvas de gravure, le meme repere que els.x/y. */
  try{
    var _mtaMesC=null;
    var _mtaMes=function(){ if(!_mtaMesC){ var cv=document.createElement('canvas'); cv.width=cv.height=8; _mtaMesC=cv.getContext('2d'); } return _mtaMesC; };
    var _mtaTxt=function(i){ var L=(state.els||[]); for(var k=0;k<L.length;k++){ if(L[k].__i===i&&L[k].type==='text')return L[k]; } return null; };
    var _mtaDims=function(){ return (_maskCv&&_maskCv.width)?{W:_maskCv.width,H:_maskCv.height}:{W:1000,H:1000}; };
    var _mtaPrep=function(x,e,W){ var fpx=sizeCqwFor(e.size||6,state.shape)/100*W; try{x.letterSpacing=(e.ls?e.ls*fpx:0)+'px';}catch(_){} x.font=(e.weight||600)+' '+fpx+'px '+engraveCss(e.font,e.weight||600); return fpx; };
    window.__MTA_LARGEUR__=function(i){
      try{
        var e=_mtaTxt(i); if(!e)return 0;
        var x=_mtaMes(),D=_mtaDims(); _mtaPrep(x,e,D.W);
        if(mtHasCurve(e)||normRot(e.rot)){var b=mtTextGeometry(x,e,sizeCqwFor(e.size||6,state.shape)/100*D.W,0,0).bounds;return (b.right-b.left)/D.W;}
        var ls=mtTextLines(e), w=0;
        ls.forEach(function(ln){ var ww=x.measureText(ln).width; if(ww>w)w=ww; });
        try{x.letterSpacing='0px';}catch(_){}
        return w/D.W;
      }catch(_){ return 0; }
    };
    window.__MTA_BOUNDS__=function(i){
      try{var e=_mtaTxt(i);if(!e||(!mtHasCurve(e)&&!normRot(e.rot)))return null;var x=_mtaMes(),D=_mtaDims(),px=_mtaPrep(x,e,D.W);
        var b=mtTextGeometry(x,e,px,(e.x!=null?e.x:.5)*D.W,(e.y!=null?e.y:.5)*D.H).bounds;
        return {x:(b.left+b.right)/2/D.W,y:(b.top+b.bottom)/2/D.H,w:(b.right-b.left)/D.W,h:(b.bottom-b.top)/D.H};
      }catch(_){return null;}
    };
    window.__MTA_INDEX_A__=function(i,fx,fy){
      try{
        var e=_mtaTxt(i); if(!e)return null;
        var x=_mtaMes(),D=_mtaDims(),fpx=_mtaPrep(x,e,D.W);
        if(mtHasCurve(e)||normRot(e.rot)||e.smallcaps){
          var cg=mtTextGeometry(x,e,fpx,(e.x!=null?e.x:.5)*D.W,(e.y!=null?e.y:.5)*D.H),best=Infinity,index=0;
          cg.carets.forEach(function(p,k){var d=Math.hypot(fx*D.W-p.x,fy*D.H-p.y);if(d<best){best=d;index=k;}});return index;
        }
        var ls=mtTextLines(e);
        var lh=fpx*MT_LH, cy=(e.y!=null?e.y:0.5)*D.H, y0=cy-(ls.length-1)*lh/2;
        var li=0,bd=1/0; ls.forEach(function(_,k){ var d=Math.abs(fy*D.H-(y0+k*lh)); if(d<bd){bd=d;li=k;} });
        var ln=ls[li]||'', lw=x.measureText(ln).width;
        var ax=(e.align==='left'?'left':(e.align==='right'?'right':'center'));
        var cx=(e.x!=null?e.x:0.5)*D.W, x0=(ax==='left')?cx:(ax==='right'?cx-lw:cx-lw/2);
        var tx=fx*D.W-x0, col=ln.length;
        if(tx<=0)col=0;
        else if(tx<lw){ for(var k2=1;k2<=ln.length;k2++){ var wp=x.measureText(ln.slice(0,k2-1)).width, wk=x.measureText(ln.slice(0,k2)).width; if(tx<(wp+wk)/2){ col=k2-1; break; } } }
        var pos=col; for(var k3=0;k3<li;k3++)pos+=ls[k3].length+1;
        try{x.letterSpacing='0px';}catch(_){}
        return pos;
      }catch(_){ return null; }
    };
  }catch(e){}

  mtpReady();
})();

/* ==================================================================== */
/* MTA_TELEM_BUREAU — les compteurs du parcours guidé SUR ORDINATEUR.   */
/* L'atelier mobile compte déjà (<760 px) ; ici on couvre l'accordéon    */
/* du bureau, aux mêmes jalons : ouvert, écrit, complet, panier, bilan. */
/* Mêmes règles de vie privée : identifiant sous consentement Shopify,  */
/* jamais de contenu saisi, robots marqués b=1 et exclus.               */
/* ==================================================================== */
(function(){
  try{
    if (!window.matchMedia || !matchMedia('(min-width: 760px)').matches) return;
    var steps = document.getElementById('mtpSteps');
    var add = document.getElementById('mtpAdd');
    if (!steps || !add) return;

    function idVisiteur(){
      try{
        var ok = false;
        try{ ok = !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }catch(_){ ok = false; }
        if (!ok) return '';
        var d = JSON.parse(localStorage.getItem('mta_vid') || 'null');
        if (!d || !d.id || (Date.now() - (d.t || 0)) > 34e9){
          d = { id: Math.random().toString(16).slice(2, 10) + Math.random().toString(16).slice(2, 6), t: Date.now() };
          localStorage.setItem('mta_vid', JSON.stringify(d));
        }
        return d.id;
      }catch(_){ return ''; }
    }
    function compter(e, extra){
      try{
        var vid = idVisiteur();
        var u = 'https://admin.mytomette.fr/compteur.php?e=' + e
          + '&c=ge'
          + '&p=' + encodeURIComponent((location.pathname.split('/').pop() || '').slice(0, 60))
          + '&a=d'
          + (vid ? '&v=' + vid : '')
          + (navigator.webdriver ? '&b=1' : '')
          + (extra || '');
        if (navigator.sendBeacon) navigator.sendBeacon(u);
        else (new Image()).src = u;
      }catch(_){}
    }
    var jalons = {};
    function jalon(nom){ if (jalons[nom]) return; jalons[nom] = 1; compter(nom); }
    var bilan = { t0: 0, editions: {}, envoye: false };
    function bilanEnvoi(panier){
      if (bilan.envoye || !bilan.t0) return;
      bilan.envoye = true;
      try{
        var noms = Object.keys(bilan.editions), reEdits = 0, top = '', topN = 0;
        noms.forEach(function(k){ var n = bilan.editions[k]; if (n > 1) reEdits += n - 1; if (n > topN){ topN = n; top = k; } });
        compter('atelier_bilan',
          '&d=' + Math.min(3600, Math.round((Date.now() - bilan.t0) / 1000))
          + '&ch=' + noms.length + '&re=' + reEdits + '&rt=0'
          + '&fin=' + (jalons.atelier_fin ? 1 : 0)
          + '&pan=' + (panier ? 1 : 0)
          + '&top=' + encodeURIComponent(topN > 1 ? top.slice(0, 30) : ''));
      }catch(_){}
    }

    /* ouvert : le premier geste dans le formulaire guidé */
    function premierGeste(){ jalon('atelier_ouvert'); }
    steps.addEventListener('pointerdown', premierGeste, { once: true, capture: true });
    steps.addEventListener('focusin', premierGeste, { once: true, capture: true });

    /* écrit + bilan : chaque saisie réelle, champ par champ (jamais le contenu) */
    steps.addEventListener('input', function(ev){
      var t = ev.target;
      if (!t || !/^(INPUT|TEXTAREA)$/.test(t.tagName) || !String(t.value || '').trim()) return;
      if (!bilan.t0) bilan.t0 = Date.now();
      var k = (t.placeholder || t.name || t.id || 'champ').slice(0, 30);
      bilan.editions[k] = (bilan.editions[k] || 0) + 1;
      jalon('atelier_ouvert');   /* écrire, c'est forcément avoir ouvert */
      jalon('atelier_ecrit');
    }, true);

    /* complet : le moteur allume le bouton quand tout le requis est là */
    if (!add.disabled) { /* déjà complet au chargement (reprise) : on attendra un geste */ }
    new MutationObserver(function(){
      if (!add.disabled && jalons.atelier_ouvert) jalon('atelier_complet');
    }).observe(add, { attributes: true, attributeFilter: ['disabled'] });

    /* panier : le clic sur le bouton allumé — canal + visiteur voyagent
       jusqu'à la commande, comme sur mobile */
    add.addEventListener('click', function(){
      if (add.disabled) return;
      jalon('atelier_complet');
      jalon('atelier_fin');
      jalon('atelier_panier');
      try{
        fetch(window.MT_CONFIG_I18N.url("/cart/update.js"), { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_mt_canal': 'ge-d', '_mt_vid': idVisiteur() || '' } }) })['catch'](function(){});
      }catch(_){}
      bilanEnvoi(true);
    }, true);

    addEventListener('pagehide', function(){ bilanEnvoi(false); });
    document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') bilanEnvoi(false); });
  }catch(_){}
})();



